var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEs = function SvgEs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#AA151B",
    d: "M0 0h512v512H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F1BF00",
    d: "M0 128h512v256H0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ad1519",
    d: "M171.7 227.6s-.5 0-.8-.2l-1.1-1-.7-.5-.7-.9s-.7-1.2-.4-2q.7-1.3 1.5-1.6c.5-.3 1.6-.6 1.6-.6l1.2-.5 1.3-.3.6-.3.9-.1 1.1-.3 1.7.1h5.1l3.6 1.2c.6.1 1.9.3 2.4.6q.9.6 1.3 1.1.3.6.4 1.1v1.1l-.5.9-.6 1-.8.7s-.6.5-1.1.5-5.1-.9-8.2-.9-7.8.9-7.8.9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.3,
    d: "M171.7 227.6s-.5 0-.8-.2l-1.1-1-.7-.5-.7-.9s-.7-1.2-.4-2q.7-1.3 1.5-1.6c.5-.3 1.6-.6 1.6-.6l1.2-.5 1.3-.3.6-.3.9-.1 1.1-.3 1.7.1h5.1l3.6 1.2c.6.1 1.9.3 2.4.6q.9.6 1.3 1.1.3.6.4 1.1v1.1l-.5.9-.6 1-.8.7s-.6.5-1.1.5-5.1-.9-8.2-.9-7.8.9-7.8.9z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "M178.2 220.9q.1-2.4 1.4-2.6 1.3.2 1.4 2.6-.1 2.3-1.4 2.5-1.3-.2-1.4-2.5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M178.2 220.9q.1-2.4 1.4-2.6 1.3.2 1.4 2.6-.1 2.3-1.4 2.5-1.3-.2-1.4-2.5z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "M179 220.9c0-1.3.3-2.4.6-2.4q.7.2.7 2.4t-.7 2.3q-.5-.2-.6-2.3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M179 220.9c0-1.3.3-2.4.6-2.4q.7.2.7 2.4t-.7 2.3q-.5-.2-.6-2.3z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "M178.7 218.2q0-.9.9-1 1.2 0 1 1c-.2 1-.5.9-1 .9a1 1 0 0 1-1-1"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "M180.3 217.8v.6h-1.5v-.6h.5v-1.3h-.7v-.6h.7v-.6h.6v.6h.6v.6h-.6v1.3z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M180.3 217.8v.6h-1.5v-.6h.5v-1.3h-.7v-.6h.7v-.6h.6v.6h.6v.6h-.6v1.3h.4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "M181 217.8v.6h-2.7v-.6h1v-1.3h-.7v-.6h.7v-.6h.6v.6h.6v.6h-.6v1.3z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M181 217.8v.6h-2.7v-.6h1v-1.3h-.7v-.6h.7v-.6h.6v.6h.6v.6h-.6v1.3h1"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M179.9 217.3a1 1 0 0 1 .6.9q0 .8-.9.9-1.2 0-1-1 .1-.6.8-.8"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "M179.6 227.4h-5v-1.2l-.3-1.2-.2-1.6c-1.4-1.8-2.6-3-3-2.7q0-.6.4-.8c1.2-.7 3.7 1 5.6 3.9l.5.7h4l.5-.7c1.9-2.9 4.4-4.6 5.6-3.9q.3.3.5.8c-.5-.3-1.7.9-3 2.7l-.3 1.6-.2 1.2-.1 1.2z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M179.6 227.4h-5v-1.2l-.3-1.2-.2-1.6c-1.4-1.8-2.6-3-3-2.7q0-.6.4-.8c1.2-.7 3.7 1 5.6 3.9l.5.7h4l.5-.7c1.9-2.9 4.4-4.6 5.6-3.9q.3.3.5.8c-.5-.3-1.7.9-3 2.7l-.3 1.6-.2 1.2-.1 1.2z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M171.3 220.6c1-.5 3 1.2 4.8 3.8m11.9-3.8c-1-.5-3.1 1.2-4.9 3.8"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "m172.3 229.6-.6-1q3.1-1 7.9-1c3 0 5.9.3 7.9 1l-.6.9-.3.8q-2.7-.9-7-.8c-2.9 0-5.6.3-7 .8z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "m172.3 229.6-.6-1q3.1-1 7.9-1c3 0 5.9.3 7.9 1l-.6.9-.3.8q-2.7-.9-7-.8c-2.9 0-5.6.3-7 .8l-.3-.7"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "M179.6 232.2a27 27 0 0 0 6.2-.7q1.1-.3 1-.8 0-.3-.3-.4a26 26 0 0 0-7-.9c-2.6 0-5.3.4-6.8.9q-.3 0-.4.4 0 .5 1 .8c1 .3 3.8.7 6.3.7"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M179.6 232.2a27 27 0 0 0 6.2-.7q1.1-.3 1-.8 0-.3-.3-.4a26 26 0 0 0-7-.9c-2.6 0-5.3.4-6.8.9q-.3 0-.4.4 0 .5 1 .8c1 .3 3.8.7 6.3.7z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "m187.6 227.4-.6-.5s-.6.3-1.3.2-1-1-1-1-.8.7-1.5.6-1-.6-1-.6-.8.5-1.4.5c-.7 0-1.3-.9-1.3-.9s-.6.9-1.2 1-1.2-.6-1.2-.6-.3.6-1 .7c-.9.1-1.6-.6-1.6-.6s-.5.7-1 1c-.6.1-1.3-.4-1.3-.4l-.2.5-.3.2.2.4a33 33 0 0 1 15.5.1z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "m187.6 227.4-.6-.5s-.6.3-1.3.2-1-1-1-1-.8.7-1.5.6-1-.6-1-.6-.8.5-1.4.5c-.7 0-1.3-.9-1.3-.9s-.6.9-1.2 1-1.2-.6-1.2-.6-.3.6-1 .7c-.9.1-1.6-.6-1.6-.6s-.5.7-1 1c-.6.1-1.3-.4-1.3-.4l-.2.5-.3.2.2.4a33 33 0 0 1 15.5.1z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "M179.6 224.8h.3a1 1 0 0 0 1 1.5q.9 0 1.2-.8l.1-.4v.5q.2.8 1.2.9a1 1 0 0 0 1.1-1.1v-.1l.4-.4.2.4-.1.5q.1 1 1 1 .7 0 1-.4l.2-.3v.4q0 .5.5.7 0 .1 1-.4l.8-.8v.5s-.5.8-1 1.1l-1 .3q-.4-.2-.7-.7l-.8.3q-1 0-1.4-1a2 2 0 0 1-1.2.6 2 2 0 0 1-1.3-.6 2 2 0 0 1-1.1.4q-1 0-1.4-.7-.5.7-1.4.7l-1-.4q-.6.5-1.4.6a2 2 0 0 1-1.2-.5q-.4.8-1.4.8-.5 0-.8-.2-.2.5-.7.7l-1-.3-1-1.1v-.5l.9.8q.8.5.9.4.5-.1.5-.7v-.4l.2.3q.3.5 1 .5.9-.1 1-1v-.6l.1-.4.4.4q.1 1.1 1 1.2 1.1 0 1.2-1v-.3l.2.3q.3.8 1.1.8 1.1-.1 1.2-1.1l-.1-.4z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M179.6 224.8h.3a1 1 0 0 0 1 1.5q.9 0 1.2-.8l.1-.4v.5q.2.8 1.2.9a1 1 0 0 0 1.1-1.1v-.1l.4-.4.2.4-.1.5q.1 1 1 1 .7 0 1-.4l.2-.3v.4q0 .5.5.7 0 .1 1-.4l.8-.8v.5s-.5.8-1 1.1l-1 .3q-.4-.2-.7-.7l-.8.3q-1 0-1.4-1a2 2 0 0 1-1.2.6 2 2 0 0 1-1.3-.6 2 2 0 0 1-1.1.4q-1 0-1.4-.7-.5.7-1.4.7l-1-.4q-.6.5-1.4.6a2 2 0 0 1-1.2-.5q-.4.8-1.4.8-.5 0-.8-.2-.2.5-.7.7l-1-.3-1-1.1v-.5l.9.8q.8.5.9.4.5-.1.5-.7v-.4l.2.3q.3.5 1 .5.9-.1 1-1v-.6l.1-.4.4.4q.1 1.1 1 1.2 1.1 0 1.2-1v-.3l.2.3q.3.8 1.1.8 1.1-.1 1.2-1.1l-.1-.4z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "M179.6 227.6q-4.8 0-7.9 1l-.3-.2q0-.3.2-.4 3.1-1 8-1c4.9 0 6 .4 8 1l.2.3q0 .3-.3.2-3.1-1-8-1"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.3,
    d: "M179.6 227.6q-4.8 0-7.9 1l-.3-.2q0-.3.2-.4 3.1-1 8-1c4.9 0 6 .4 8 1l.2.3q0 .3-.3.2-3.1-1-8-1z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M176.6 228.7q0-.5.5-.5.3 0 .4.5 0 .3-.5.4-.6 0-.4-.4"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M176.6 228.7q0-.5.5-.5.3 0 .4.5 0 .3-.5.4-.6 0-.4-.4z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#ad1519",
    d: "M179.6 228.8h-1l-.3-.3q0-.2.3-.3h2a.3.3 0 0 1 .4.3.3.3 0 0 1-.4.3z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M179.6 228.8h-1l-.3-.3q0-.2.3-.3h2a.3.3 0 0 1 .4.3.3.3 0 0 1-.4.3h-1"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#058e6e",
    d: "M174.7 229.2h-.7q-.3.1-.4-.2l.2-.3.7-.1.8-.2q.3 0 .4.3 0 .3-.3.4h-.8"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M174.7 229.2h-.7q-.3.1-.4-.2l.2-.3.7-.1.8-.2q.3 0 .4.3 0 .3-.3.4h-.8"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#ad1519",
    d: "m171.8 229.7.3-.5.7.1-.4.6z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "m171.8 229.7.3-.5.7.1-.4.6-.6-.2"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M181.7 228.7q0-.5.4-.5t.5.5q0 .3-.5.4-.6 0-.4-.4"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M181.7 228.7q0-.5.4-.5t.5.5q0 .3-.5.4-.6 0-.4-.4z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#058e6e",
    d: "M184.5 229.2h.8q.2.1.3-.2l-.2-.3-.8-.1-.7-.2q-.3 0-.4.3 0 .3.3.4z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M184.5 229.2h.8q.2.1.3-.2l-.2-.3-.8-.1-.7-.2q-.3 0-.4.3 0 .3.3.4h.7"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#ad1519",
    d: "m187.3 229.7-.2-.5h-.7l.3.6h.7"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "m187.3 229.7-.2-.5h-.7l.3.6h.7"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "#ad1519",
    d: "M179.6 231.6q-3.9 0-6.5-.7a27 27 0 0 1 6.5-.7q3.8 0 6.5.7-2.7.7-6.5.7"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.3,
    d: "M179.6 231.6q-3.9 0-6.5-.7a27 27 0 0 1 6.5-.7q3.8 0 6.5.7-2.7.7-6.5.7z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "M187.4 226.2v-.4q-.3 0-.5.2 0 .3.2.5.2 0 .3-.3"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M187.4 226.2v-.4q-.3 0-.5.2 0 .3.2.5.2 0 .3-.3z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "M182.5 225.2q0-.3-.2-.4-.3 0-.3.4t.2.4.3-.4"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M182.5 225.2q0-.3-.2-.4-.3 0-.3.4t.2.4.3-.4z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "M176.7 225.2q0-.3.2-.4.3 0 .3.4t-.2.4z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M176.7 225.2q0-.3.2-.4.3 0 .3.4t-.2.4z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "M171.8 226.2q-.1-.3.1-.4t.4.2q0 .3-.2.5-.2 0-.3-.3"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M171.8 226.2q-.1-.3.1-.4t.4.2q0 .3-.2.5-.2 0-.3-.3z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "m179.6 222.4-.9.5.7 1.4.2.2.2-.2.7-1.4-1-.5"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "m179.6 222.4-.9.5.7 1.4.2.2.2-.2.7-1.4-1-.5"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "m177.7 224.5.4.6 1.3-.4.2-.2-.2-.2-1.3-.4z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "m177.7 224.5.4.6 1.3-.4.2-.2-.2-.2-1.3-.4-.4.6"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "m181.5 224.5-.4.6-1.3-.4-.2-.2.1-.2 1.4-.4z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "m181.5 224.5-.4.6-1.3-.4-.2-.2.1-.2 1.4-.4.4.6"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "m173.9 223-.7.6.9 1.2.2.1.2-.2.3-1.4z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "m173.9 223-.7.6.9 1.2.2.1.2-.2.3-1.4-1-.3"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "m172.4 225.3.5.5 1.3-.7v-.4h-1.5z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "m172.4 225.3.5.5 1.3-.7v-.4h-1.5l-.3.6"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "m176.2 224.6-.3.6-1.4-.1-.2-.2.1-.2 1.3-.7z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "m176.2 224.6-.3.6-1.4-.1-.2-.2.1-.2 1.3-.7.5.6"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "M171 225.5v.7l-1.5.1h-.2v-.3l1.1-1z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M171 225.5v.7l-1.5.1h-.2v-.3l1.1-1 .6.5"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "M173.8 225q0-.6.5-.6t.5.5a1 1 0 0 1-.5.5 1 1 0 0 1-.5-.5"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M173.8 225q0-.6.5-.6t.5.5a1 1 0 0 1-.5.5 1 1 0 0 1-.5-.5z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "m185.3 223 .7.6-.9 1.2-.2.1-.2-.2-.3-1.4z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "m185.3 223 .7.6-.9 1.2-.2.1-.2-.2-.3-1.4 1-.3"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "m186.8 225.3-.6.5-1.2-.7-.1-.2.2-.2h1.4z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "m186.8 225.3-.6.5-1.2-.7-.1-.2.2-.2h1.4l.3.6"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "m183 224.6.3.6 1.4-.1.2-.2-.1-.2-1.3-.7z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "m183 224.6.3.6 1.4-.1.2-.2-.1-.2-1.3-.7-.5.6"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "M188 225.5v.7l1.5.1h.2v-.3l-1.1-1z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M188 225.5v.7l1.5.1h.2v-.3l-1.1-1-.6.5"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "M179 224.5a.5.5 0 0 1 .6-.5q.5 0 .5.5a1 1 0 0 1-.5.4 1 1 0 0 1-.5-.4"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M179 224.5a.5.5 0 0 1 .6-.5q.5 0 .5.5a1 1 0 0 1-.5.4 1 1 0 0 1-.5-.4z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "M184.4 225a.5.5 0 0 1 .5-.6 1 1 0 0 1 .5.5 1 1 0 0 1-.5.5 1 1 0 0 1-.5-.5"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M184.4 225a.5.5 0 0 1 .5-.6 1 1 0 0 1 .5.5 1 1 0 0 1-.5.5 1 1 0 0 1-.5-.5z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "m169.1 226.3-.7-.8-.7-.3s.3-.3.6-.3l.5.2v-.2s.3 0 .4.4v1"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "m169.1 226.3-.7-.8-.7-.3s.3-.3.6-.3l.5.2v-.2s.3 0 .4.4v1z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "m169.1 226 .6.1q.3.3 0 .5-.4.2-.4 0-.3-.3-.2-.5"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "m169.1 226 .6.1q.3.3 0 .5-.4.2-.4 0-.3-.3-.2-.5z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "m189.9 226.3.7-.8.7-.3s-.3-.3-.6-.3l-.5.2v-.2s-.3 0-.4.4v.7z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "m189.9 226.3.7-.8.7-.3s-.3-.3-.6-.3l-.5.2v-.2s-.3 0-.4.4v.7z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "m189.9 226-.5.1q-.3.3-.2.5h.6q.3-.3.1-.5"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "m189.9 226-.5.1q-.3.3-.2.5h.6q.3-.3.1-.5z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "M168.2 238h22.9v-6h-22.9z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M168.2 238h22.9v-6h-22.9z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "m170.6 242 .5-.1h17.5q-1-.3-1-1.3.1-1 1-1.4l-.5.1h-17.5q1 .3 1 1.3t-1 1.3"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.4,
    d: "m170.6 242 .5-.1h17.5q-1-.3-1-1.3.1-1 1-1.4l-.5.1h-17.5q1 .3 1 1.3t-1 1.3z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "M171 241.9h17.2q.9 0 1 .8-.1.7-1 .8H171q-1-.1-1.1-.8.1-.8 1-.8"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M171 241.9h17.2q.9 0 1 .8-.1.7-1 .8H171q-1-.1-1.1-.8.1-.8 1-.8z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "M171 238h17.2q.9 0 1 .6-.1.7-1 .7H171q-1 0-1-.7t1-.7"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M171 238h17.2q.9 0 1 .6-.1.7-1 .7H171q-1 0-1-.7t1-.7z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fill: "#005bbf",
    d: "M195.6 338.6a9 9 0 0 1-4-.9 9 9 0 0 0-4-.8q-2.5 0-4 .8a9 9 0 0 1-4 1 9 9 0 0 1-4-1 9 9 0 0 0-4-.8 9 9 0 0 0-3.9.8q-1.6 1-4 1v2.4a9 9 0 0 0 4-1 9 9 0 0 1 4-.8 9 9 0 0 1 3.9.9 9 9 0 0 0 4 .9 9 9 0 0 0 4-.9 9 9 0 0 1 4-.9q2.4 0 4 .9a9 9 0 0 0 4 .9z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M195.6 338.6a9 9 0 0 1-4-.9 9 9 0 0 0-4-.8q-2.5 0-4 .8a9 9 0 0 1-4 1 9 9 0 0 1-4-1 9 9 0 0 0-4-.8 9 9 0 0 0-3.9.8q-1.6 1-4 1v2.4a9 9 0 0 0 4-1 9 9 0 0 1 4-.8 9 9 0 0 1 3.9.9 9 9 0 0 0 4 .9 9 9 0 0 0 4-.9 9 9 0 0 1 4-.9q2.4 0 4 .9a9 9 0 0 0 4 .9z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fill: "#ccc",
    d: "M195.6 341a9 9 0 0 1-4-.8 9 9 0 0 0-4-.8q-2.5 0-4 .8a9 9 0 0 1-4 .9 9 9 0 0 1-4-1 9 9 0 0 0-4-.8q-2.3 0-3.9.9a9 9 0 0 1-4 .9v2.4a9 9 0 0 0 4-.9 9 9 0 0 1 4-.8 9 9 0 0 1 3.9.8 9 9 0 0 0 4 1 9 9 0 0 0 4-1 9 9 0 0 1 4-.8 9 9 0 0 1 4 .9 9 9 0 0 0 4 .9z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M195.6 341a9 9 0 0 1-4-.8 9 9 0 0 0-4-.8q-2.5 0-4 .8a9 9 0 0 1-4 .9 9 9 0 0 1-4-1 9 9 0 0 0-4-.8q-2.3 0-3.9.9a9 9 0 0 1-4 .9v2.4a9 9 0 0 0 4-.9 9 9 0 0 1 4-.8 9 9 0 0 1 3.9.8 9 9 0 0 0 4 1 9 9 0 0 0 4-1 9 9 0 0 1 4-.8 9 9 0 0 1 4 .9 9 9 0 0 0 4 .9V341"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fill: "#005bbf",
    d: "M195.6 343.6a9 9 0 0 1-4-1 9 9 0 0 0-4-.8 9 9 0 0 0-4 .9 9 9 0 0 1-4 .9 9 9 0 0 1-4-1 9 9 0 0 0-4-.8 9 9 0 0 0-3.9.8 9 9 0 0 1-4 1v2.4q2.4 0 4-.9a9 9 0 0 1 4-.8 9 9 0 0 1 3.9.8 9 9 0 0 0 8 0 9 9 0 0 1 4-.8q2.4 0 4 .8 1.5 1 4 1v-2.6"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M195.6 343.6a9 9 0 0 1-4-1 9 9 0 0 0-4-.8 9 9 0 0 0-4 .9 9 9 0 0 1-4 .9 9 9 0 0 1-4-1 9 9 0 0 0-4-.8 9 9 0 0 0-3.9.8 9 9 0 0 1-4 1v2.4q2.4 0 4-.9a9 9 0 0 1 4-.8 9 9 0 0 1 3.9.8 9 9 0 0 0 8 0 9 9 0 0 1 4-.8q2.4 0 4 .8 1.5 1 4 1v-2.6"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fill: "#ccc",
    d: "M195.6 348.5a9 9 0 0 1-4-1 9 9 0 0 0-4-.7 9 9 0 0 0-4 .8 9 9 0 0 1-4 .9 9 9 0 0 1-4-1 9 9 0 0 0-4-.7 9 9 0 0 0-3.9.8 9 9 0 0 1-4 .9V346a9 9 0 0 0 4-.9 9 9 0 0 1 4-.8 9 9 0 0 1 3.9.8q1.5 1 4 1a9 9 0 0 0 4-1 9 9 0 0 1 4-.8 9 9 0 0 1 4 .8q1.5 1 4 1z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M195.6 348.5a9 9 0 0 1-4-1 9 9 0 0 0-4-.7 9 9 0 0 0-4 .8 9 9 0 0 1-4 .9 9 9 0 0 1-4-1 9 9 0 0 0-4-.7 9 9 0 0 0-3.9.8 9 9 0 0 1-4 .9V346a9 9 0 0 0 4-.9 9 9 0 0 1 4-.8 9 9 0 0 1 3.9.8q1.5 1 4 1a9 9 0 0 0 4-1 9 9 0 0 1 4-.8 9 9 0 0 1 4 .8q1.5 1 4 1v2.4"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fill: "#005bbf",
    d: "M195.6 351a9 9 0 0 1-4-1 9 9 0 0 0-4-.8 9 9 0 0 0-4 .9 9 9 0 0 1-4 .8 9 9 0 0 1-4-.9 9 9 0 0 0-4-.8 9 9 0 0 0-3.9.8q-1.6 1-4 1v-2.5q2.4 0 4-1a9 9 0 0 1 4-.7 9 9 0 0 1 3.9.8 9 9 0 0 0 4 .9 9 9 0 0 0 4-.9 9 9 0 0 1 4-.8 9 9 0 0 1 4 .8 9 9 0 0 0 4 .9z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M195.6 351a9 9 0 0 1-4-1 9 9 0 0 0-4-.8 9 9 0 0 0-4 .9 9 9 0 0 1-4 .8 9 9 0 0 1-4-.9 9 9 0 0 0-4-.8 9 9 0 0 0-3.9.8q-1.6 1-4 1v-2.5q2.4 0 4-1a9 9 0 0 1 4-.7 9 9 0 0 1 3.9.8 9 9 0 0 0 4 .9 9 9 0 0 0 4-.9 9 9 0 0 1 4-.8 9 9 0 0 1 4 .8 9 9 0 0 0 4 .9z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "m170.6 328.5.2.6c0 1.5-1.3 2.7-3 2.7h23.6c-1.6 0-2.9-1.2-2.9-2.7l.1-.6h-.5z"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.4,
    d: "m170.6 328.5.2.6c0 1.5-1.3 2.7-3 2.7h23.6c-1.6 0-2.9-1.2-2.9-2.7l.1-.6h-.5z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "M171 327h17.2q.9 0 1 .7-.1.8-1 .8H171q-1 0-1.1-.8.1-.7 1-.8"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M171 327h17.2q.9 0 1 .7-.1.8-1 .8H171q-1 0-1.1-.8.1-.7 1-.8z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "M168 337.8h23.3v-6H168z"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M168 337.8h23.3v-6H168z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    fill: "#ad1519",
    d: "M166 305.8c-2.2 1.3-3.8 2.7-3.5 3.4q.1.8 1.9 1.8c1.6 1.1 2.6 3.2 1.8 4.1a6 6 0 0 0-.1-9.3"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M166 305.8c-2.2 1.3-3.8 2.7-3.5 3.4q.1.8 1.9 1.8c1.6 1.1 2.6 3.2 1.8 4.1a6 6 0 0 0-.1-9.3z"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    fill: "#ccc",
    d: "M171.3 326h16.6v-81.6h-16.6z"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M183.1 244.5V326m2-81.4V326m-13.8 0h16.6v-81.5h-16.6z"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    fill: "#ad1519",
    d: "M205 275a53 53 0 0 0-17-3 52 52 0 0 0-8 .8c-9.9 1.7-17.5 5.6-16.9 8.9v.2l-3.7-8.7c-.7-3.6 7.7-8 18.8-9.8a57 57 0 0 1 9.8-.8c7 0 13.2.9 16.9 2.3v10"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.4,
    d: "M205 275a53 53 0 0 0-17-3 52 52 0 0 0-8 .8c-9.9 1.7-17.5 5.6-16.9 8.9v.2l-3.7-8.7c-.7-3.6 7.7-8 18.8-9.8a57 57 0 0 1 9.8-.8c7 0 13.2.9 16.9 2.3v10"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    fill: "#ad1519",
    d: "M171.3 285.1c-4.7-.3-7.8-1.5-8.2-3.5-.3-1.5 1.3-3.2 4-4.7q2 .2 4.2.3v8"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M171.3 285.1c-4.7-.3-7.8-1.5-8.2-3.5-.3-1.5 1.3-3.2 4-4.7q2 .2 4.2.3v8"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    fill: "#ad1519",
    d: "M188 279q4.4.5 6 2l.2.1c.5 1-2 3.3-6.3 5.8v-8"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M188 279q4.4.5 6 2l.2.1c.5 1-2 3.3-6.3 5.8v-8"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    fill: "#ad1519",
    d: "M160.9 300.9c-.4-1.3 4-4 10.4-6.3 3-1 5.3-2.1 8.3-3.4 8.9-4 15.4-8.4 14.6-10l-.1-.2c.5.4 1.2 8.4 1.2 8.4.8 1.5-5.2 6-13.3 9.8-2.6 1.3-8.1 3.3-10.7 4.2-4.7 1.6-9.3 4.7-8.9 5.8z"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.4,
    d: "M160.9 300.9c-.4-1.3 4-4 10.4-6.3 3-1 5.3-2.1 8.3-3.4 8.9-4 15.4-8.4 14.6-10l-.1-.2c.5.4 1.2 8.4 1.2 8.4.8 1.5-5.2 6-13.3 9.8-2.6 1.3-8.1 3.3-10.7 4.2-4.7 1.6-9.3 4.7-8.9 5.8z"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "M170.1 271c2-.7 3.4-1.6 2.7-3.2q-.6-1.5-3-.7l-2.8 1 2.5 6.2.9-.3.8-.3zm-1.2-3 .7-.2q1-.4 1.5.8.5.8-.5 1.6l-.7.3zm7.7-2.6-.8.3h-1l1.5 6.5 4.5-.9-.2-.4v-.4l-2.7.7zm9 5.6 2.9-6.8h-1.1l-2 5q-1.3-2.4-2.4-4.7l-1 .1h-1.1l3.7 6.5.5-.1zm9.4-5 .5-.9a4 4 0 0 0-1.9-.6q-2.7-.1-3 1.7c-.2 2.3 3.4 2.1 3.3 3.7q-.3 1-1.6.8-1.3 0-1.5-1.2h-.2l-.5 1.2q.8.4 1.9.6c1.8.2 3.3-.6 3.4-1.8.2-2.2-3.4-2.3-3.3-3.6q0-1 1.4-.8 1 0 1.3 1z"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    fill: "#ad1519",
    d: "M332.4 225.7s-.8.8-1.3 1c-.6 0-1.3-.6-1.3-.6s-.5.5-1.1.7-1.4-.7-1.4-.7-.6.8-1.2 1-1.1-.2-1.1-.2-.2.4-.7.6h-.5l-.6-.5-.7-.7-.6-.2-.3-1.1-.1-.6q0-1.1 2.4-1.8 1.2-.2 2 0a6 6 0 0 1 3.3-.8 6 6 0 0 1 3.2.7 6 6 0 0 1 3-.7q2.3 0 3.3.8a4 4 0 0 1 2.1 0q2.4.7 2.4 1.8v.6l-.4 1-.6.3-.7.8-.6.3s-.3.2-.5.1q-.7-.4-.7-.6c0-.2-.6.4-1.2.2s-1-1-1-1-.9.8-1.5.7q-1-.5-1.1-.7c-.1-.2-.7.6-1.2.5s-1.4-.9-1.4-.9"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M332.4 225.7s-.8.8-1.3 1c-.6 0-1.3-.6-1.3-.6s-.5.5-1.1.7-1.4-.7-1.4-.7-.6.8-1.2 1-1.1-.2-1.1-.2-.2.4-.7.6h-.5l-.6-.5-.7-.7-.6-.2-.3-1.1-.1-.6q0-1.1 2.4-1.8 1.2-.2 2 0a6 6 0 0 1 3.3-.8 6 6 0 0 1 3.2.7 6 6 0 0 1 3-.7q2.3 0 3.3.8a4 4 0 0 1 2.1 0q2.4.7 2.4 1.8v.6l-.4 1-.6.3-.7.8-.6.3s-.3.2-.5.1q-.7-.4-.7-.6c0-.2-.6.4-1.2.2s-1-1-1-1-.9.8-1.5.7q-1-.5-1.1-.7c-.1-.2-.7.6-1.2.5s-1.4-.9-1.4-.9z"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "M331 221.4q.1-1.8 1.3-2 1.3.2 1.4 2c.1 1.8-.6 2-1.4 2q-1.3-.2-1.4-2"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M331 221.4q.1-1.8 1.3-2 1.3.2 1.4 2c.1 1.8-.6 2-1.4 2q-1.3-.2-1.4-2z"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "M331.7 221.4c0-1 .3-1.9.7-1.9s.6.9.6 1.9q0 1.7-.7 1.8-.5-.2-.6-1.8"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M331.7 221.4c0-1 .3-1.9.7-1.9s.6.9.6 1.9q0 1.7-.7 1.8-.5-.2-.6-1.8z"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "m325 229.6-.5-1q3-1 7.8-1t8 1l-.6.9-.4.8q-2.7-.9-7-.8c-2.8 0-5.6.3-7 .8l-.2-.7"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "m325 229.6-.5-1q3-1 7.8-1t8 1l-.6.9-.4.8q-2.7-.9-7-.8c-2.8 0-5.6.3-7 .8l-.2-.7"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "M332.3 232.2c2.5 0 5.3-.4 6.3-.7q1-.3 1-.8 0-.3-.4-.4a26 26 0 0 0-6.9-.9 26 26 0 0 0-6.8.9q-.4 0-.4.4t1 .8c1 .3 3.7.7 6.2.7"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M332.3 232.2c2.5 0 5.3-.4 6.3-.7q1-.3 1-.8 0-.3-.4-.4a26 26 0 0 0-6.9-.9 26 26 0 0 0-6.8.9q-.4 0-.4.4t1 .8c1 .3 3.7.7 6.2.7z"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M338.4 222.3a1 1 0 0 1 .4-.5q.5 0 .5.5 0 .3-.5.4z"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.2,
    d: "M338.4 222.3a1 1 0 0 1 .4-.5q.5 0 .5.5 0 .3-.5.4zm-.3-1.6a1 1 0 0 1 .5-.4q.3 0 .4.4 0 .5-.4.5a1 1 0 0 1-.5-.4zm-1.1-1 .4-.3q.5 0 .5.4t-.5.4l-.4-.4zm-1.5-.4q0-.3.5-.4l.4.4a1 1 0 0 1-.4.5q-.5 0-.5-.5zm-1.5 0a1 1 0 0 1 .5-.4q.5 0 .5.5t-.5.4a1 1 0 0 1-.5-.4z"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.3,
    d: "m343 225.3.2-1.1a3 3 0 0 0-3-3l-1.3.4"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "m337.8 223.2.3-.9c0-1.2-1.3-2.1-2.7-2.1q-1 0-1.7.4"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.2,
    d: "M343.4 224q0-.5.4-.5.6 0 .5.4-.1.6-.5.5t-.4-.5zm-.2-1.7q0-.3.5-.4.3 0 .4.4 0 .5-.5.4t-.4-.4zm-1-1.2a1 1 0 0 1 .4-.5q.5 0 .5.5t-.5.4a1 1 0 0 1-.5-.4zm-1.5-.7q.1-.3.5-.4.5 0 .5.4a1 1 0 0 1-.5.5 1 1 0 0 1-.4-.5zm-1.4 0q0-.3.4-.4.5 0 .5.5t-.5.4q-.6-.2-.4-.4z"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "m340.3 227.4-.6-.5s-.6.3-1.3.2-1-1-1-1-.7.7-1.4.6-1.1-.6-1.1-.6-.7.5-1.4.5-1.2-.9-1.2-.9-.7.9-1.3 1-1.1-.6-1.1-.6-.3.6-1.1.7-1.5-.6-1.5-.6-.5.7-1 1c-.6.1-1.3-.4-1.3-.4l-.2.5-.4.2.2.4a33 33 0 0 1 15.5.1z"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "m340.3 227.4-.6-.5s-.6.3-1.3.2-1-1-1-1-.7.7-1.4.6-1.1-.6-1.1-.6-.7.5-1.4.5-1.2-.9-1.2-.9-.7.9-1.3 1-1.1-.6-1.1-.6-.3.6-1.1.7-1.5-.6-1.5-.6-.5.7-1 1c-.6.1-1.3-.4-1.3-.4l-.2.5-.4.2.2.4a33 33 0 0 1 15.5.1z"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M325.3 222.3a1 1 0 0 1 .5-.5 1 1 0 0 1 .4.5l-.4.4q-.5 0-.5-.4"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.2,
    d: "M325.3 222.3a1 1 0 0 1 .5-.5 1 1 0 0 1 .4.5l-.4.4q-.5 0-.5-.4zm.3-1.6.4-.4a1 1 0 0 1 .5.4 1 1 0 0 1-.5.5.4.4 0 0 1-.4-.4zm1.1-1q0-.2.5-.3t.5.4q-.1.6-.5.4a1 1 0 0 1-.5-.4zm1.5-.4q0-.3.4-.4.5 0 .5.4t-.5.5q-.4 0-.4-.5zm1.5 0 .4-.4a1 1 0 0 1 .5.5q0 .3-.5.4z"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.3,
    d: "m321.7 225.3-.3-1.1a3 3 0 0 1 3-3q.7 0 1.3.4"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "m326.9 223.2-.3-.9c0-1.2 1.2-2.1 2.7-2.1q1 0 1.6.4"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.2,
    d: "M320.3 224q0-.5.5-.5t.5.4a1 1 0 0 1-.5.5q-.5 0-.5-.5zm.2-1.7q0-.3.5-.4.6 0 .4.4t-.4.4a1 1 0 0 1-.5-.4zm1-1.2q.1-.5.5-.5a1 1 0 0 1 .5.5 1 1 0 0 1-.5.4l-.4-.4zm1.5-.7.4-.4q.5 0 .5.4a1 1 0 0 1-.5.5 1 1 0 0 1-.5-.5zm1.4 0q0-.3.5-.4a1 1 0 0 1 .4.5q0 .3-.4.4-.5 0-.5-.4z"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "M332.4 224.8h.2v.4q.1 1 1.1 1 .8 0 1.1-.7l.2-.4v.5q.2.8 1.1.9a1 1 0 0 0 1.2-1.1v-.1l.3-.4.2.4v.5q0 1 1 1a1 1 0 0 0 1-.4l.1-.3v.4q0 .5.5.7 0 .1 1-.4l.8-.8v.5s-.5.8-1 1.1q-.4.2-1 .3-.5-.2-.6-.7l-.8.3q-1.1 0-1.5-1a2 2 0 0 1-1.2.6 2 2 0 0 1-1.3-.6q-.5.4-1 .4a2 2 0 0 1-1.5-.7 2 2 0 0 1-2.4.3 2 2 0 0 1-1.3.6q-.8 0-1.2-.5-.4.8-1.5.8-.4 0-.8-.2-.1.5-.7.7l-1-.3-1-1.1v-.5l1 .8q.7.5.8.4.5-.1.5-.7v-.4l.3.3q.3.5.9.5 1-.1 1-1v-.6l.2-.4.3.4q.1 1.1 1.1 1.2t1.2-1v-.3l.2.3q.3.8 1 .8a1.1 1.1 0 0 0 1.2-1.5z"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M332.4 224.8h.2v.4q.1 1 1.1 1 .8 0 1.1-.7l.2-.4v.5q.2.8 1.1.9a1 1 0 0 0 1.2-1.1v-.1l.3-.4.2.4v.5q0 1 1 1a1 1 0 0 0 1-.4l.1-.3v.4q0 .5.5.7 0 .1 1-.4l.8-.8v.5s-.5.8-1 1.1q-.4.2-1 .3-.5-.2-.6-.7l-.8.3q-1.1 0-1.5-1a2 2 0 0 1-1.2.6 2 2 0 0 1-1.3-.6q-.5.4-1 .4a2 2 0 0 1-1.5-.7 2 2 0 0 1-2.4.3 2 2 0 0 1-1.3.6q-.8 0-1.2-.5-.4.8-1.5.8-.4 0-.8-.2-.1.5-.7.7l-1-.3-1-1.1v-.5l1 .8q.7.5.8.4.5-.1.5-.7v-.4l.3.3q.3.5.9.5 1-.1 1-1v-.6l.2-.4.3.4q.1 1.1 1.1 1.2t1.2-1v-.3l.2.3q.3.8 1 .8a1.1 1.1 0 0 0 1.2-1.5z"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "M332.3 227.6q-4.6 0-7.8 1l-.4-.2.2-.4q3.2-1 8-1c4.8 0 6 .4 8 1q.3 0 .2.3t-.3.2q-3.1-1-7.9-1"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M332.3 227.6q-4.6 0-7.8 1l-.4-.2.2-.4q3.2-1 8-1c4.8 0 6 .4 8 1q.3 0 .2.3t-.3.2q-3.1-1-7.9-1z"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M329.4 228.7q0-.5.4-.5t.5.5q-.1.3-.5.4-.5 0-.5-.4"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M329.4 228.7q0-.5.4-.5t.5.5q-.1.3-.5.4-.5 0-.5-.4z"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    fill: "#ad1519",
    d: "M332.4 228.8h-1q-.4 0-.4-.3t.4-.3h2l.3.3q0 .3-.3.3z"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M332.4 228.8h-1q-.4 0-.4-.3t.4-.3h2l.3.3q0 .3-.3.3h-1"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    fill: "#058e6e",
    d: "M327.4 229.2h-.7a.3.3 0 0 1-.4-.2l.3-.3.7-.1.7-.2q.3 0 .4.3 0 .3-.3.4z"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M327.4 229.2h-.7a.3.3 0 0 1-.4-.2l.3-.3.7-.1.7-.2q.3 0 .4.3 0 .3-.3.4h-.7"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    fill: "#ad1519",
    d: "m324.5 229.7.4-.5.6.1-.4.6z"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "m324.5 229.7.4-.5.6.1-.4.6-.6-.2"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M334.4 228.7q0-.5.5-.5t.4.5q0 .3-.4.4-.5 0-.5-.4"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M334.4 228.7q0-.5.5-.5t.4.5q0 .3-.4.4-.5 0-.5-.4z"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    fill: "#058e6e",
    d: "M337.3 229.2h.7q.3.1.4-.2l-.3-.3-.7-.1-.7-.2q-.3 0-.4.3 0 .3.3.4z"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M337.3 229.2h.7q.3.1.4-.2l-.3-.3-.7-.1-.7-.2q-.3 0-.4.3 0 .3.3.4h.7"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    fill: "#ad1519",
    d: "m340.1 229.7-.3-.5h-.7l.4.6z"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "m340.1 229.7-.3-.5h-.7l.4.6h.6"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    fill: "#ad1519",
    d: "M332.3 231.6a27 27 0 0 1-6.4-.7 28 28 0 0 1 13 0 27 27 0 0 1-6.6.7"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.3,
    d: "M332.3 231.6a27 27 0 0 1-6.4-.7 28 28 0 0 1 13 0 27 27 0 0 1-6.6.7z"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "m340.2 226.2-.1-.4q-.3 0-.4.2l.1.5q.3 0 .4-.3"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "m340.2 226.2-.1-.4q-.3 0-.4.2l.1.5q.3 0 .4-.3z"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "M335.2 225.2q0-.3-.2-.4-.2 0-.3.4t.2.4.3-.4"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M335.2 225.2q0-.3-.2-.4-.2 0-.3.4t.2.4.3-.4z"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "M329.5 225.2q0-.3.2-.4.2 0 .3.4t-.2.4-.3-.4"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M329.5 225.2q0-.3.2-.4.2 0 .3.4t-.2.4-.3-.4z"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "m324.5 226.2.1-.4q.3 0 .4.2l-.1.5q-.3 0-.4-.3"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "m324.5 226.2.1-.4q.3 0 .4.2l-.1.5q-.3 0-.4-.3z"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "m332.3 222.4-.8.5.6 1.4.2.2.3-.2.6-1.4z"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "m332.3 222.4-.8.5.6 1.4.2.2.3-.2.6-1.4-.9-.5"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "m330.4 224.5.4.6 1.4-.4.1-.2-.1-.2-1.4-.4z"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "m330.4 224.5.4.6 1.4-.4.1-.2-.1-.2-1.4-.4-.4.6"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "m334.3 224.5-.4.6-1.4-.4-.1-.2.1-.2 1.4-.4z"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "m334.3 224.5-.4.6-1.4-.4-.1-.2.1-.2 1.4-.4.4.6"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "m326.6 223-.7.6 1 1.2.2.1.1-.2.3-1.4z"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "m326.6 223-.7.6 1 1.2.2.1.1-.2.3-1.4-.9-.3"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "m325.2 225.3.5.5 1.2-.7.1-.2-.1-.2h-1.5z"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "m325.2 225.3.5.5 1.2-.7.1-.2-.1-.2h-1.5l-.2.6"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "m329 224.6-.3.6-1.4-.1-.2-.2v-.2l1.3-.7z"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "m329 224.6-.3.6-1.4-.1-.2-.2v-.2l1.3-.7.6.6"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "m323.8 225.5-.1.7-1.5.1h-.2v-.3l1.2-1z"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "m323.8 225.5-.1.7-1.5.1h-.2v-.3l1.2-1 .6.5"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "M326.6 225a.5.5 0 0 1 .5-.6 1 1 0 0 1 .5.5 1 1 0 0 1-.5.5 1 1 0 0 1-.5-.5"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M326.6 225a.5.5 0 0 1 .5-.6 1 1 0 0 1 .5.5 1 1 0 0 1-.5.5 1 1 0 0 1-.5-.5z"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "m338 223 .8.6-1 1.2-.2.1-.1-.2-.3-1.4z"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "m338 223 .8.6-1 1.2-.2.1-.1-.2-.3-1.4.9-.3"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "m339.5 225.3-.5.5-1.3-.7v-.2l.1-.2h1.5z"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "m339.5 225.3-.5.5-1.3-.7v-.2l.1-.2h1.5l.2.6"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "m335.7 224.6.3.6 1.4-.1.2-.2v-.2l-1.3-.7z"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "m335.7 224.6.3.6 1.4-.1.2-.2v-.2l-1.3-.7-.6.6"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "m340.7 225.5.1.7 1.4.1h.3v-.3l-1.2-1z"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "m340.7 225.5.1.7 1.4.1h.3v-.3l-1.2-1-.6.5"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "M331.8 224.5q.1-.5.5-.5.6 0 .5.5 0 .3-.5.4a1 1 0 0 1-.5-.4"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M331.8 224.5q.1-.5.5-.5.6 0 .5.5 0 .3-.5.4a1 1 0 0 1-.5-.4z"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "M337.1 225a.5.5 0 0 1 .5-.6q.5 0 .5.5t-.5.5a1 1 0 0 1-.5-.5"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M337.1 225a.5.5 0 0 1 .5-.6q.5 0 .5.5t-.5.5a1 1 0 0 1-.5-.5z"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "M331.4 219q0-.7 1-.8c1-.1.9.4.9.9s-.4.9-1 .9a1 1 0 0 1-.9-1"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "M333 218.8v.6h-1.5v-.6h.5v-1.4h-.6v-.6h.6v-.5h.7v.5h.6v.6h-.6v1.4z"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M333 218.8v.6h-1.5v-.6h.5v-1.4h-.6v-.6h.6v-.5h.7v.5h.6v.6h-.6v1.4z"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "M333.7 218.8v.6H331v-.6h1v-1.4h-.7v-.6h.6v-.5h.7v.5h.6v.6h-.6v1.4z"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M332.6 218.2a1 1 0 0 1 .7.9q0 .8-1 .9a1 1 0 0 1-.9-1q0-.6.7-.8"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "m321.9 226.3-.7-.8-.7-.3s.3-.3.6-.3l.5.2v-.2s.2 0 .3.4q.1.6 0 .7z"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "m321.9 226.3-.7-.8-.7-.3s.3-.3.6-.3l.5.2v-.2s.2 0 .3.4q.1.6 0 .7z"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "m321.9 226 .5.1q.4.3.1.5h-.5q-.3-.3-.1-.5"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "m321.9 226 .5.1q.4.3.1.5h-.5q-.3-.3-.1-.5z"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "m342.6 226.3.7-.8.7-.3s-.3-.3-.6-.3l-.5.2v-.2s-.3 0-.4.4v.7z"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "m342.6 226.3.7-.8.7-.3s-.3-.3-.6-.3l-.5.2v-.2s-.3 0-.4.4v.7z"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "m342.6 226-.5.1q-.3.3-.1.5t.5 0q.4-.3.1-.5"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "m342.6 226-.5.1q-.3.3-.1.5t.5 0q.4-.3.1-.5z"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "M321 238h22.8v-6h-22.9z"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M321 238h22.8v-6h-22.9z"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "m341.4 242-.4-.1h-17.6q1-.3 1-1.3-.1-1-1-1.4l.4.1h17.6q-1 .3-1 1.3t1 1.3"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.4,
    d: "m341.4 242-.4-.1h-17.6q1-.3 1-1.3-.1-1-1-1.4l.4.1h17.6q-1 .3-1 1.3t1 1.3z"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "M323.9 241.9h17q1 0 1.1.8-.1.7-1 .8h-17.1q-1-.1-1-.8t1-.8"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M323.9 241.9h17q1 0 1.1.8-.1.7-1 .8h-17.1q-1-.1-1-.8t1-.8z"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "M323.9 238h17q1 0 1.1.6-.1.7-1 .7h-17.1q-1 0-1.1-.7.1-.7 1-.7"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M323.9 238h17q1 0 1.1.6-.1.7-1 .7h-17.1q-1 0-1.1-.7.1-.7 1-.7z"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    fill: "#005bbf",
    d: "M316.4 338.6q2.5 0 4-.9a9 9 0 0 1 4-.8q2.4 0 4 .8 1.6 1 4 1a9 9 0 0 0 4-1 9 9 0 0 1 4-.8q2.3 0 3.9.8 1.6 1 4 1v2.4a9 9 0 0 1-4-1 9 9 0 0 0-4-.8q-2.2 0-3.9.9a9 9 0 0 1-4 .9 9 9 0 0 1-4-.9 9 9 0 0 0-4-.9q-2.4 0-4 .9a9 9 0 0 1-4 .9z"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M316.4 338.6q2.5 0 4-.9a9 9 0 0 1 4-.8q2.4 0 4 .8 1.6 1 4 1a9 9 0 0 0 4-1 9 9 0 0 1 4-.8q2.3 0 3.9.8 1.6 1 4 1v2.4a9 9 0 0 1-4-1 9 9 0 0 0-4-.8q-2.2 0-3.9.9a9 9 0 0 1-4 .9 9 9 0 0 1-4-.9 9 9 0 0 0-4-.9q-2.4 0-4 .9a9 9 0 0 1-4 .9z"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    fill: "#ccc",
    d: "M316.4 341a9 9 0 0 0 4-.8 9 9 0 0 1 4-.8q2.4 0 4 .8a9 9 0 0 0 4 .9q2.5 0 4-1a9 9 0 0 1 4-.8 8 8 0 0 1 3.9.9 9 9 0 0 0 4 .9v2.4a9 9 0 0 1-4-.9 9 9 0 0 0-4-.8q-2.2 0-3.9.8a9 9 0 0 1-4 1 9 9 0 0 1-4-1 9 9 0 0 0-4-.8 9 9 0 0 0-4 .9 9 9 0 0 1-4 .9z"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M316.4 341a9 9 0 0 0 4-.8 9 9 0 0 1 4-.8q2.4 0 4 .8a9 9 0 0 0 4 .9q2.5 0 4-1a9 9 0 0 1 4-.8 8 8 0 0 1 3.9.9 9 9 0 0 0 4 .9v2.4a9 9 0 0 1-4-.9 9 9 0 0 0-4-.8q-2.2 0-3.9.8a9 9 0 0 1-4 1 9 9 0 0 1-4-1 9 9 0 0 0-4-.8 9 9 0 0 0-4 .9 9 9 0 0 1-4 .9V341"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    fill: "#005bbf",
    d: "M316.4 343.6q2.5 0 4-1a9 9 0 0 1 4-.8 9 9 0 0 1 4 .9q1.6.8 4 .9 2.5 0 4-1a9 9 0 0 1 4-.8q2.3 0 3.9.8 1.6 1 4 1v2.4a9 9 0 0 1-4-.9 9 9 0 0 0-4-.8 9 9 0 0 0-3.9.8 9 9 0 0 1-4 1 9 9 0 0 1-4-1 9 9 0 0 0-4-.8q-2.4 0-4 .8a9 9 0 0 1-4 1v-2.6"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M316.4 343.6q2.5 0 4-1a9 9 0 0 1 4-.8 9 9 0 0 1 4 .9q1.6.8 4 .9 2.5 0 4-1a9 9 0 0 1 4-.8q2.3 0 3.9.8 1.6 1 4 1v2.4a9 9 0 0 1-4-.9 9 9 0 0 0-4-.8 9 9 0 0 0-3.9.8 9 9 0 0 1-4 1 9 9 0 0 1-4-1 9 9 0 0 0-4-.8q-2.4 0-4 .8a9 9 0 0 1-4 1v-2.6"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    fill: "#ccc",
    d: "M316.4 348.5a9 9 0 0 0 4-1 9 9 0 0 1 4-.7 9 9 0 0 1 4 .8q1.6.8 4 .9 2.5 0 4-1a9 9 0 0 1 4-.7q2.3 0 3.9.8t4 .9V346a9 9 0 0 1-4-.9 9 9 0 0 0-4-.8 9 9 0 0 0-3.9.8 9 9 0 0 1-4 1 9 9 0 0 1-4-1 9 9 0 0 0-4-.8 9 9 0 0 0-4 .8 9 9 0 0 1-4 1z"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M316.4 348.5a9 9 0 0 0 4-1 9 9 0 0 1 4-.7 9 9 0 0 1 4 .8q1.6.8 4 .9 2.5 0 4-1a9 9 0 0 1 4-.7q2.3 0 3.9.8t4 .9V346a9 9 0 0 1-4-.9 9 9 0 0 0-4-.8 9 9 0 0 0-3.9.8 9 9 0 0 1-4 1 9 9 0 0 1-4-1 9 9 0 0 0-4-.8 9 9 0 0 0-4 .8 9 9 0 0 1-4 1v2.4"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    fill: "#005bbf",
    d: "M316.4 351q2.5 0 4-1a9 9 0 0 1 4-.8 9 9 0 0 1 4 .9q1.6.8 4 .8 2.5 0 4-.9a9 9 0 0 1 4-.8q2.3 0 3.9.8 1.6 1 4 1v-2.5a9 9 0 0 1-4-1 9 9 0 0 0-4-.7q-2.2 0-3.9.8a9 9 0 0 1-4 .9 9 9 0 0 1-4-.9 9 9 0 0 0-4-.8 9 9 0 0 0-4 .8 9 9 0 0 1-4 .9z"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M316.4 351q2.5 0 4-1a9 9 0 0 1 4-.8 9 9 0 0 1 4 .9q1.6.8 4 .8 2.5 0 4-.9a9 9 0 0 1 4-.8q2.3 0 3.9.8 1.6 1 4 1v-2.5a9 9 0 0 1-4-1 9 9 0 0 0-4-.7q-2.2 0-3.9.8a9 9 0 0 1-4 .9 9 9 0 0 1-4-.9 9 9 0 0 0-4-.8 9 9 0 0 0-4 .8 9 9 0 0 1-4 .9z"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "m341.4 328.5-.2.6c0 1.5 1.3 2.7 3 2.7h-23.6c1.6 0 2.9-1.2 2.9-2.7v-.6z"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.4,
    d: "m341.4 328.5-.2.6c0 1.5 1.3 2.7 3 2.7h-23.6c1.6 0 2.9-1.2 2.9-2.7v-.6z"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "M323.9 327h17q1 0 1.1.7-.1.8-1 .8h-17.1q-1 0-1-.8 0-.7 1-.8"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M323.9 327h17q1 0 1.1.7-.1.8-1 .8h-17.1q-1 0-1-.8 0-.7 1-.8z"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "M320.7 337.8H344v-6h-23.4z"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M320.7 337.8H344v-6h-23.4z"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    fill: "#ad1519",
    d: "M346 305.8c2.2 1.3 3.8 2.7 3.6 3.4q-.4.8-2 1.8c-1.6 1.1-2.6 3.2-1.8 4.1a6 6 0 0 1 .1-9.3"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M346 305.8c2.2 1.3 3.8 2.7 3.6 3.4q-.4.8-2 1.8c-1.6 1.1-2.6 3.2-1.8 4.1a6 6 0 0 1 .1-9.3z"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    fill: "#ccc",
    d: "M324 326h16.7v-81.6h-16.6z"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M336.2 244.4v81.4m1.8-81.4v81.4m-14 .2h16.7v-81.6h-16.6z"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    fill: "#ad1519",
    d: "M307 275a53 53 0 0 1 25-2.2c9.9 1.7 17.5 5.6 16.9 8.9v.2s3.7-8.4 3.7-8.7c.7-3.6-7.7-8-18.8-9.8a57 57 0 0 0-9.8-.8c-7 0-13.2.9-16.9 2.3v10"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.4,
    d: "M307 275a53 53 0 0 1 25-2.2c9.9 1.7 17.5 5.6 16.9 8.9v.2s3.7-8.4 3.7-8.7c.7-3.6-7.7-8-18.8-9.8a57 57 0 0 0-9.8-.8c-7 0-13.2.9-16.9 2.3v10"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    fill: "#ad1519",
    d: "M340.8 285.1c4.6-.3 7.7-1.5 8-3.5q.4-2.4-4-4.7-1.8.2-4 .3v8"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M340.8 285.1c4.6-.3 7.7-1.5 8-3.5q.4-2.4-4-4.7-1.8.2-4 .3v8"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    fill: "#ad1519",
    d: "M324 279q-4.4.5-6 2l-.2.1c-.5 1 2 3.3 6.3 5.8v-8"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M324 279q-4.4.5-6 2l-.2.1c-.5 1 2 3.3 6.3 5.8v-8"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    fill: "#ad1519",
    d: "M351.1 300.9c.4-1.3-4-4-10.4-6.3-3-1-5.3-2.1-8.3-3.4-8.8-4-15.4-8.4-14.6-10l.1-.2c-.4.4-1.2 8.4-1.2 8.4-.8 1.5 5.2 6 13.3 9.8 2.6 1.3 8.1 3.3 10.7 4.2 4.7 1.6 9.3 4.7 8.9 5.8z"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.4,
    d: "M351.1 300.9c.4-1.3-4-4-10.4-6.3-3-1-5.3-2.1-8.3-3.4-8.8-4-15.4-8.4-14.6-10l.1-.2c-.4.4-1.2 8.4-1.2 8.4-.8 1.5 5.2 6 13.3 9.8 2.6 1.3 8.1 3.3 10.7 4.2 4.7 1.6 9.3 4.7 8.9 5.8z"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "M317.5 271.3q1-3.6 2.2-7l-.5.1h-.6q-.6 2.6-1.5 5.1l-2.9-4.4-1 .2-1 .1 4.2 6h1.1m6.3-7H322l-.2 6.5h4.6v-.8l-2.7.1zm7.3 1.1 2.1.3v-.4l.1-.4-6.2-.5v.8h2.2l-.6 6h1l.8.1zm2.5 6.5q.4 0 1 .2l.8.2.7-3h.1l.5 1.2 1 2.3q.5 0 1 .2l1.1.2-.3-.6-1.5-3.1q1.8 0 2.3-1.3.2-1-.7-1.6l-1.9-.6-2.5-.5zm3.2-5.6c.8.2 1.7.3 1.7 1.1v.5q-.4 1.5-2.3 1zm8.7 7.6-.3 2.1.9.5.9.5.6-7.4-.8-.4-6.6 4.1.6.3.4.3 1.8-1.4zm-1.9-1.7 2.2-1.4-.3 2.4z"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M230.3 205.3c0-1.2 1-2.1 2.2-2.1q2.1.2 2.3 2c0 1.2-1 2.2-2.3 2.2a2 2 0 0 1-2.2-2.1z"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    fill: "#ad1519",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M255.3 187.1c6.8 0 13 1 16.8 2.6a32 32 0 0 0 8.6 2.2q4 .5 7 .2c2.9 0 6.9.8 11 2.6a29 29 0 0 1 8 5l-1.7 1.5-.4 4-4.4 5-2.2 2-5.3 4-2.6.3-.8 2.3-33.7-4-33.8 4-.9-2.3-2.6-.2-5.2-4.2-2.2-1.9-4.4-5-.5-4-1.6-1.5a30 30 0 0 1 8-5c4-1.8 8-2.6 10.9-2.6q3 .3 7-.2a32 32 0 0 0 8.6-2.2q6.1-2.5 16.4-2.6z"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M255.9 231.6c-12.6 0-23.8-1.5-31.9-4q-1-.2-.8-1.2a1 1 0 0 1 .8-1.2 120 120 0 0 1 31.9-4c12.5.1 23.8 1.6 31.8 4q.9.4.9 1.2 0 1-1 1.3a119 119 0 0 1-31.7 4"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    fill: "#ad1519",
    d: "M255.8 230a121 121 0 0 1-29.3-3.4c7.8-2 18-3.2 29.3-3.2a123 123 0 0 1 29.5 3.2c-7.8 2-18.1 3.4-29.5 3.4"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M256.7 230v-6.7m-1.9 6.7v-6.7"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.2,
    d: "M253.1 230v-6.7m-1.7 6.7v-6.7"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M249.9 230v-6.7m-2.9 6.4v-6.2m1.4 6.2v-6.4"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M244.3 229.4v-5.7m1.4 5.9v-6m-5 5.4v-4.9m1.2 5V224m1.2 5.4V224"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.5,
    d: "M239.4 229v-4.8m-1.1 4.6v-4.5"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.6,
    d: "M237 228.7v-4.2m-2.6 3.8V225m1.4 3.5v-3.7"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.7,
    d: "M233.1 228v-2.9m-1.2 2.7v-2.4"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.8,
    d: "M230.6 227.5v-2m-1.4 1.8v-1.4"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.9,
    d: "M227.8 227v-.7"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M264 229.7v-6.2m-3.2 6.4v-6.6m-2.2 6.6v-6.6"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M255.8 221.3a115 115 0 0 0-32.2 4c.7-.3.6-1-.2-3.2-1-2.6-2.6-2.5-2.6-2.5a130 130 0 0 1 35-4.3c13.8 0 26.2 1.7 35.1 4.3 0 0-1.5-.1-2.5 2.5q-1.3 3-.3 3.3c-8-2.5-19.6-4.1-32.3-4.1"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M255.8 215.3a131 131 0 0 0-35 4.3q-1 .3-1.4-.6a1 1 0 0 1 .8-1.4c8.9-2.7 21.6-4.4 35.6-4.4s26.9 1.7 35.8 4.4q1 .5.7 1.4t-1.4.6c-8.9-2.6-21.3-4.2-35-4.3"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.4,
    d: "M255.8 230a121 121 0 0 1-29.3-3.4c7.8-2 18-3.2 29.3-3.2a123 123 0 0 1 29.5 3.2c-7.8 2-18.1 3.4-29.5 3.4z"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M246 218.5q.1-1 1.1-1.1 1.1.1 1.2 1t-1.2 1.1a1 1 0 0 1-1-1"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    fill: "#ad1519",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M255.9 219.3h-3.4q-1-.1-1.1-1 .1-1 1-1.1h6.9a1 1 0 0 1 1.1 1q-.1 1-1.1 1.1h-3.4"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    fill: "#058e6e",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "m239 220.2-2.5.3q-1 0-1.2-1a1 1 0 0 1 1-1.1l2.4-.3 2.5-.3a1 1 0 0 1 1.2 1q0 .9-1 1.1l-2.5.3"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M229.1 220.4q.1-.9 1.1-1a1 1 0 0 1 1.2 1q0 1-1.2 1.1a1 1 0 0 1-1-1"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    fill: "#ad1519",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "m221.6 222.4 1.3-1.7 3.4.5-2.7 2-2-.8"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    fill: "#058e6e",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "m272.8 220.2 2.4.3q1 0 1.3-1a1 1 0 0 0-1-1.1l-2.5-.3-2.4-.3q-1.1 0-1.3 1 0 .9 1 1.1l2.5.3"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M263.4 218.5q.2-1 1.2-1.1c1-.1 1.1.5 1.1 1q-.1 1-1.1 1.1a1 1 0 0 1-1.2-1m17 2q.1-1 1-1.1a1 1 0 0 1 1.2 1q-.1 1-1.1 1.1a1 1 0 0 1-1.1-1"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    fill: "#ad1519",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "m290 222.4-1.2-1.7-3.4.5 2.8 2 1.9-.8"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M225.1 227c8-2.3 18.7-3.6 30.7-3.7 12 0 22.9 1.4 30.8 3.7"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "m230.4 196 1.5 1.1 2.1-3.4a8 8 0 0 1-3.8-7.6c.2-4.5 5.6-8.1 12.5-8.1q5.4.1 9 2.5l.2-1.9a19 19 0 0 0-9.2-2.3c-8 0-14.1 4.4-14.4 9.8a10 10 0 0 0 3.3 8z"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "m230.4 196 1.5 1.1 2.1-3.4a8 8 0 0 1-3.8-7.6c.2-4.5 5.6-8.1 12.5-8.1q5.4.1 9 2.5l.2-1.9a19 19 0 0 0-9.2-2.3c-8 0-14.1 4.4-14.4 9.8a10 10 0 0 0 3.3 8l-1.2 2"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "M230.5 196a10 10 0 0 1-4.3-7.7c0-3.5 2.2-6.6 5.7-8.6a9 9 0 0 0-3.6 6.4 10 10 0 0 0 3.3 8l-1 2"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M230.5 196a10 10 0 0 1-4.3-7.7c0-3.5 2.2-6.6 5.7-8.6a9 9 0 0 0-3.6 6.4 10 10 0 0 0 3.3 8l-1 2"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "M206.8 199.6a9 9 0 0 1-2.5-6.3q0-2.2 1-4c2.1-4.5 9-7.8 17.1-7.8q3.4 0 6.3.7-.7.8-1 1.5a27 27 0 0 0-5.3-.5c-7.4 0-13.6 3-15.4 6.8a8 8 0 0 0-.8 3.3 8 8 0 0 0 2.9 6l-2.7 4.4-1.5-1.2z"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M206.8 199.6a9 9 0 0 1-2.5-6.3q0-2.2 1-4c2.1-4.5 9-7.8 17.1-7.8q3.4 0 6.3.7-.7.8-1 1.5a27 27 0 0 0-5.3-.5c-7.4 0-13.6 3-15.4 6.8a8 8 0 0 0-.8 3.3 8 8 0 0 0 2.9 6l-2.7 4.4-1.5-1.2z"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "M209.5 184.8a11 11 0 0 0-4.2 4.4 9 9 0 0 0-1 4.1q.1 3.7 2.5 6.3l-1.7 2.6a11 11 0 0 1-2.4-6.8c0-4.3 2.7-8.1 6.8-10.6"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M209.5 184.8a11 11 0 0 0-4.2 4.4 9 9 0 0 0-1 4.1q.1 3.7 2.5 6.3l-1.7 2.6a11 11 0 0 1-2.4-6.8c0-4.3 2.7-8.1 6.8-10.6z"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "M255.8 175.4c1.7 0 3.3 1.2 3.7 2.8q.3 2.1.4 4.7v1.2q.1 5.5 1.3 8.7l-5.5 5.2-5.5-5.2q1.1-3.2 1.3-8.7v-1.2q0-2.6.5-4.7c.3-1.6 2-2.8 3.7-2.8"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M255.8 175.4c1.7 0 3.3 1.2 3.7 2.8q.3 2.1.4 4.7v1.2q.1 5.5 1.3 8.7l-5.5 5.2-5.5-5.2q1.1-3.2 1.3-8.7v-1.2q0-2.6.5-4.7c.3-1.6 2-2.8 3.7-2.8z"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "M255.8 177a2 2 0 0 1 1.9 1.5l.4 4.5v1.1c0 3.4.5 6.4 1.2 8.2l-3.6 3.5-3.6-3.5c.7-1.8 1.2-4.8 1.2-8.2V183q0-2.4.5-4.5.4-1.3 2-1.4"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M255.8 177a2 2 0 0 1 1.9 1.5l.4 4.5v1.1c0 3.4.5 6.4 1.2 8.2l-3.6 3.5-3.6-3.5c.7-1.8 1.2-4.8 1.2-8.2V183q0-2.4.5-4.5.4-1.3 2-1.4z"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "m281 196-1.4 1.1-2.2-3.4a8 8 0 0 0 3.9-7.6c-.2-4.5-5.7-8.1-12.5-8.1a16 16 0 0 0-9 2.5l-.3-1.9a19 19 0 0 1 9.3-2.3c7.9 0 14 4.4 14.4 9.8a10 10 0 0 1-3.3 8z"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "m281 196-1.4 1.1-2.2-3.4a8 8 0 0 0 3.9-7.6c-.2-4.5-5.7-8.1-12.5-8.1a16 16 0 0 0-9 2.5l-.3-1.9a19 19 0 0 1 9.3-2.3c7.9 0 14 4.4 14.4 9.8a10 10 0 0 1-3.3 8l1.1 1.9"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "M280.9 196q4.2-3.1 4.4-7.7c0-3.5-2.3-6.6-5.7-8.6a9 9 0 0 1 3.6 7.3q-.2 4.3-3.3 7.2l1 1.9"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M280.9 196q4.2-3.1 4.4-7.7c0-3.5-2.3-6.6-5.7-8.6a9 9 0 0 1 3.6 7.3q-.2 4.3-3.3 7.2l1 1.9"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "M304.7 199.6a9 9 0 0 0 1.5-10.3c-2.2-4.5-9-7.8-17.2-7.8a28 28 0 0 0-6.3.7q.7.8 1.1 1.5a27 27 0 0 1 5.2-.5c7.5 0 13.7 3 15.5 6.8q.8 1.5.8 3.3a8 8 0 0 1-3 6l2.8 4.4 1.4-1.2z"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M304.7 199.6a9 9 0 0 0 1.5-10.3c-2.2-4.5-9-7.8-17.2-7.8a28 28 0 0 0-6.3.7q.7.8 1.1 1.5a27 27 0 0 1 5.2-.5c7.5 0 13.7 3 15.5 6.8q.8 1.5.8 3.3a8 8 0 0 1-3 6l2.8 4.4 1.4-1.2z"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "M302 184.8a11 11 0 0 1 4.2 4.4 9 9 0 0 1 1 4.1q-.1 3.7-2.5 6.3l1.6 2.6a11 11 0 0 0 2.5-6.8c0-4.3-2.7-8.1-6.9-10.6"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M302 184.8a11 11 0 0 1 4.2 4.4 9 9 0 0 1 1 4.1q-.1 3.7-2.5 6.3l1.6 2.6a11 11 0 0 0 2.5-6.8c0-4.3-2.7-8.1-6.9-10.6z"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M253.8 193.5c0-1 .9-1.9 2-1.9 1 0 1.9.9 1.9 1.9a2 2 0 0 1-2 1.8 2 2 0 0 1-2-1.8"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M253.8 193.5c0-1 .9-1.9 2-1.9 1 0 1.9.9 1.9 1.9a2 2 0 0 1-2 1.8 2 2 0 0 1-2-1.8z"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M253.8 189.8a2 2 0 0 1 2-1.8 2 2 0 0 1 1.9 1.9 2 2 0 0 1-2 1.8 2 2 0 0 1-2-1.8m.5-4q.1-1.3 1.5-1.4 1.5 0 1.6 1.5-.1 1.3-1.6 1.4-1.4-.1-1.5-1.4m.4-3.6q.1-.9 1.1-1a1 1 0 0 1 1.2 1q0 1-1.2 1.1a1 1 0 0 1-1-1m.1-3.1q0-.8 1-.9c1-.1.8.4.8.9s-.4.8-.9.8-.9-.3-.9-.8"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "m255.9 204.6 1.3.2a5 5 0 0 0 4.8 6.4 5 5 0 0 0 4.8-3.3s.4-1.7.6-1.7.2 1.9.3 1.9c.3 2.4 2.5 4 5 4a5 5 0 0 0 5-5.4l1.5-1.5.9 2a4 4 0 0 0-.5 2 4.7 4.7 0 0 0 4.8 4.6 5 5 0 0 0 4-2l1-1.3v1.6c0 1.5.7 3 2.2 3.2 0 0 1.8.1 4.1-1.7a28 28 0 0 0 3.7-3.4l.2 1.9s-2 3-4 4.2c-1.2.7-3 1.4-4.4 1.1s-2.6-1.4-3.1-2.7a7 7 0 0 1-3.6 1 7 7 0 0 1-6.5-4 7.5 7.5 0 0 1-11-.3 7 7 0 0 1-5 1.9 7 7 0 0 1-6.1-3.1 7 7 0 0 1-6.1 3 7 7 0 0 1-5-1.8 7.5 7.5 0 0 1-11 .3 7 7 0 0 1-6.5 4 7 7 0 0 1-3.6-1q-.9 2.2-3.1 2.8c-1.4.2-3.2-.5-4.3-1.2-2.2-1.2-4.1-4.3-4.1-4.3l.2-1.8s1.3 1.5 3.6 3.4c2.4 1.8 4.2 1.7 4.2 1.7 1.5-.2 2.2-1.7 2.2-3.2v-1.6l1 1.3a5 5 0 0 0 4 2c2.6 0 4.8-2 4.8-4.6q0-1-.5-2l.8-2 1.6 1.5v.6a5 5 0 0 0 5 4.8c2.5 0 4.7-1.7 5-4 0 0 0-1.9.2-1.9s.7 1.8.7 1.7a5 5 0 0 0 4.8 3.3 5 5 0 0 0 4.8-6.4l1.3-.2"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M290.5 210.8c.3-.8 0-1.7-.6-1.8q-1.1-.2-1.6 1.2c-.3.8 0 1.7.5 1.8q1 .2 1.7-1.2m-22-4.2q.2-1.4-.9-1.7-1 0-1.3 1.4-.1 1.6 1 1.8 1 0 1.3-1.5m-25.4 0q-.1-1.4 1-1.7 1 0 1.3 1.4.1 1.6-1 1.8-1 0-1.3-1.5m-22 4.3q-.3-1.4.7-2 1-.1 1.6 1.3.4 1.4-.6 1.9-1 0-1.6-1.2"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M230.8 196.3a6 6 0 0 1 2.4 3s0-.2.7-.6q1-.4 1.1-.3l-.2 1.4c-.1.3-.1 1.4-.4 2.3l-.6 1.8a2 2 0 0 0-1.6-.5 2 2 0 0 0-1.4 1s-.7-.6-1.2-1.4l-1.2-2.2-.7-1.2h1.1q1 .2 1 .3a5 5 0 0 1 1-3.7"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M231.3 206.7a2 2 0 0 1-.7-1.1 2 2 0 0 1 .2-1.3l-1.9-.7c-.7-.2-2-.2-2.4-.2h-1.2l.3.6.5.7a5 5 0 0 0-3 2.2 6 6 0 0 0 3.6 1l-.2.8v.7l1-.4c.4-.2 1.6-.6 2.2-1q1.5-1.1 1.6-1.3m2.9-.5a2 2 0 0 0 .2-1.2 2 2 0 0 0-.7-1.1s.7-.8 1.5-1.3l2.3-1 1-.4v.6l-.2.9a6 6 0 0 1 3.7 1 5 5 0 0 1-3.1 2.1l.8 1.4h-1.2c-.4 0-1.7 0-2.4-.3-1-.2-2-.7-2-.7"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    fill: "#ad1519",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M230.3 205.3c0-1.2 1-2.1 2.2-2.1q2.1.2 2.3 2c0 1.2-1 2.2-2.3 2.2a2 2 0 0 1-2.2-2.1"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M255.8 192.9a6 6 0 0 1 2 3.9s.2-.3 1-.6 1.2-.1 1.2-.1l-.5 1.4c-.2.4-.4 1.6-.9 2.6l-1 1.8a2 2 0 0 0-1.8-.7q-1 0-1.7.7-.2 0-1-1.8c-.5-1-.7-2.2-.9-2.6l-.6-1.4s.6-.1 1.3.2q1.1.4 1 .5a6 6 0 0 1 2-4"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M254.2 204.6a2 2 0 0 1-.6-1.3q0-.8.6-1.4s-1-.7-2-1.1c-.8-.4-2.2-.6-2.6-.7l-1.3-.3.1.7.4 1q-2.3.2-3.9 1.8a6 6 0 0 0 4 1.8l-.5 1-.2.6 1.4-.2 2.6-.7 2-1.2m3.3 0q.5-.5.5-1.3a2 2 0 0 0-.5-1.4s1-.7 2-1.1c.8-.4 2.2-.6 2.6-.7l1.3-.3-.2.7-.4 1a6 6 0 0 1 4 1.8 6 6 0 0 1-4 1.8l.4 1 .2.6-1.3-.2-2.6-.7-2-1.2m23.5-8.4a6 6 0 0 0-2.4 3.1l-.7-.6q-1-.4-1.1-.3l.2 1.4.3 2.3.7 1.8a2 2 0 0 1 1.6-.5 2 2 0 0 1 1.4 1l1.2-1.4 1.2-2.2.7-1.2h-1.2q-1 .2-.9.3a5 5 0 0 0-1-3.7"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M280.5 206.7q.5-.5.7-1.1a2 2 0 0 0-.2-1.3l1.8-.7c.8-.2 2-.2 2.5-.2h1.1l-.2.6-.6.7a5 5 0 0 1 3.1 2.2 6 6 0 0 1-3.6 1l.2.8v.7l-1-.4-2.3-1-1.5-1.3m-2.9-.5a2 2 0 0 1-.3-1.2q.2-.8.7-1.1s-.7-.8-1.5-1.3c-.6-.4-1.8-.9-2.2-1l-1-.4v.6q.1.8.2.9a6 6 0 0 0-3.7 1q1.1 1.6 3 2.1l-.4.8-.3.6h1.2c.4 0 1.7 0 2.4-.3 1-.2 1.9-.7 1.9-.7"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    fill: "#ad1519",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M277 205.3q.2-2 2.2-2.1 2.1.2 2.3 2c0 1.2-1 2.2-2.3 2.2a2 2 0 0 1-2.2-2.1m24.8 4.6c-.5-.5-1.6-.4-2.4.3s-1 1.7-.5 2.2 1.6.5 2.4-.2q1.2-1.2.5-2.3"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M298.7 211.3q.1-.6.7-1.1c.8-.7 2-.8 2.4-.3l.2.3s1.2-2.1 2.5-2.9 3.6-.5 3.6-.5a3 3 0 0 0-3.1-3q-1.6 0-2.5 1.2l-.3-1.1s-1.4.3-2 1.8c-.6 1.7 0 4 0 4s-.3-1-.8-1.7a9 9 0 0 0-2.6-1.7l-1.4-.8v1.5a8 8 0 0 0-4 .5 5 5 0 0 0 2.7 2.3l-.8.8-.5.5 1.4.2c.4 0 1.8.3 2.7.2l1.8-.2m-85.6 0a2 2 0 0 0-.8-1.1c-.8-.7-1.9-.8-2.4-.3l-.2.3s-1-2.1-2.4-2.9-3.6-.5-3.6-.5a3 3 0 0 1 3-3q1.6 0 2.6 1.2l.2-1.1s1.4.3 2 1.9 0 3.9 0 3.9.4-1 .9-1.7 1.8-1.4 2.5-1.7l1.4-.8v1.5a8 8 0 0 1 4 .5 5 5 0 0 1-2.7 2.3l.9.8.4.5-1.3.2c-.4 0-1.9.3-2.7.2l-1.8-.2"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    fill: "#ad1519",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M210 210q1-.9 2.3.2c.9.7 1 1.7.6 2.2q-1 .9-2.4-.2t-.6-2.3m43.7-6.6q.2-2 2.3-2.1c2.1-.1 2.2.9 2.2 2s-1 2.2-2.3 2.2a2 2 0 0 1-2.2-2.1"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    fill: "#005bbf",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M251.2 171.3c0-2.4 2-4.3 4.6-4.3s4.5 2 4.5 4.3a4.4 4.4 0 0 1-4.5 4.3 4.4 4.4 0 0 1-4.6-4.3"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M254.6 159.3v2.3H252v2.3h2.5v6.8h-3.2l-.2.6q0 1 .4 1.7h8.3l.4-1.7-.2-.6h-3V164h2.4v-2.3H257v-2.3z"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    fill: "#ccc",
    d: "M256.2 352.6a87 87 0 0 1-37.8-8.8 24 24 0 0 1-13.7-21.6V288h102.8v34c0 9.5-5.4 17.7-13.7 21.8a86 86 0 0 1-37.6 8.7"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.5,
    d: "M256.2 352.6a87 87 0 0 1-37.8-8.8 24 24 0 0 1-13.7-21.6V288h102.8v34c0 9.5-5.4 17.7-13.7 21.8a86 86 0 0 1-37.6 8.7z"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    fill: "#ccc",
    d: "M256 288h51.5v-57H256z"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.5,
    d: "M256 288h51.5v-57H256z"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    fill: "#ad1519",
    d: "M256 322.1a25 25 0 0 1-25.6 24.4c-14.2 0-25.8-11-25.8-24.4V288H256v34"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    stroke: "#000",
    strokeWidth: 0.5,
    d: "M215.8 342.3c1.7.8 3.9 2.2 6.2 2.8l-.1-58.3h-6v55.4z"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.5,
    d: "M204.5 321.7a26 26 0 0 0 6 16v-50.6h-5.9z"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    fill: "#c7b500",
    stroke: "#000",
    strokeWidth: 0.5,
    d: "M227.3 346.4c2.4.2 4.1.2 6 0v-59.6h-6z"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    stroke: "#000",
    strokeWidth: 0.5,
    d: "M238.6 345a20 20 0 0 0 6.2-2.6v-55.6h-6z"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    fill: "#ad1519",
    d: "M204.6 288H256v-57h-51.4z"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.5,
    d: "M204.6 288H256v-57h-51.4z"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    stroke: "#000",
    strokeWidth: 0.5,
    d: "M250.4 337.1c2.5-2.2 4.9-7.3 5.7-13l.2-37.3h-6V337z"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.5,
    d: "M256 322.1a25 25 0 0 1-25.6 24.4c-14.2 0-25.8-11-25.8-24.4V288H256v34"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    fill: "#ad1519",
    d: "M307.6 288v34a25 25 0 0 1-25.8 24.4c-14.2 0-25.8-11-25.8-24.4v-34z"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.5,
    d: "M307.6 288v34a25 25 0 0 1-25.8 24.4c-14.2 0-25.8-11-25.8-24.4v-34h51.6"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "m265.4 313.7.1.6q0 1-1.2 1.1-1-.1-1.2-1.1 0-.3.2-.5h-1.7a3 3 0 0 0 1.9 3v4.1h1.7v-4.1a3 3 0 0 0 1.8-1.7h4.7v-1.4zm23.1 0v1.4h-4.2l-.3.6 5 5.6-1.4 1-4.9-5.6-.2.1v9.3h-1.8v-9.3l-.2-.1-5 5.6-1.4-1 5.1-5.7-.2-.5h-4.4v-1.4h14zm2.8 0v1.4h4.8q.4 1.2 1.7 1.7v4.1h1.8v-4.1a3 3 0 0 0 2-2.5l-.2-.6h-1.6a1.2 1.2 0 0 1-1 1.7q-1.2-.1-1.3-1.1l.1-.5zm-7 23.5a17 17 0 0 0 3.8-1l.9 1.4a19 19 0 0 1-4.6 1.3 3 3 0 0 1-2.8 2 3 3 0 0 1-2.7-2 19 19 0 0 1-4.8-1.3l.8-1.5q2 .9 4.2 1.2a3 3 0 0 1 1.6-1.5v-7.1h1.8v7.1a3 3 0 0 1 1.7 1.4zm-11.8-2.4-.9 1.5a18 18 0 0 1-3.9-3.3 3 3 0 0 1-2.6-.5 2.5 2.5 0 0 1-.4-3.7l.2-.2a16 16 0 0 1-1.4-5.1h1.8a14 14 0 0 0 1.1 4.4l1.5.1 4.4-4.8 1.3 1-4.4 4.9a3 3 0 0 1 0 3 16 16 0 0 0 3.2 2.7zm-6.5-5a1.2 1.2 0 0 1 1.7-.2 1 1 0 0 1 0 1.6 1.3 1.3 0 0 1-1.6.2 1 1 0 0 1-.1-1.6m-2.2-4.8-1.8-.4-.3-4.6 1.8-.6v2.6q0 1.5.2 3zm1.4-5.7 1.8.4v2.3c0-.8.3 2.3.3 2.3l-1.8.6-.3-2.9zm6 14.6a17 17 0 0 0 5.1 2.7l.4-1.7a15 15 0 0 1-4.3-2.1zm-1 1.6a19 19 0 0 0 5.2 2.7l-1.3 1.3a20 20 0 0 1-4.2-2.2zm2.3-10 1.7.7 3.2-3.5-1-1.5zm-1.3-1-1-1.5 3.1-3.5 1.7.7zm19.3 10.5.9 1.5a18 18 0 0 0 3.8-3.3q1.6.4 2.7-.5a2.5 2.5 0 0 0 .3-3.7l-.1-.2q1.1-2.4 1.3-5.1h-1.7a14 14 0 0 1-1.2 4.4l-1.5.1-4.3-4.8-1.3 1 4.3 4.9a3 3 0 0 0 .1 3 16 16 0 0 1-3.3 2.7m6.5-5a1.2 1.2 0 0 0-1.7-.2 1 1 0 0 0-.1 1.6q.8.8 1.7.1a1 1 0 0 0 0-1.6zm2.2-4.8 1.8-.5.2-4.5-1.7-.6v2.6zm-1.5-5.7-1.8.4v2.3c0-.8-.3 2.3-.3 2.3l1.9.6.2-2.9zm-6 14.6a17 17 0 0 1-5 2.7l-.5-1.7a15 15 0 0 0 4.3-2.1zm.9 1.6a19 19 0 0 1-5.2 2.7l1.3 1.3a20 20 0 0 0 4.3-2.2zm-2.4-10-1.7.7-3.1-3.5 1-1.5zm1.4-1 1-1.5-3.2-3.5-1.7.7 3.8 4.3m-21.4-9.3.5 1.7h4.8l.6-1.7zm22.5 0-.5 1.7h-4.8l-.5-1.7zm-12.4 23.3q0-1 1.2-1.1 1 .1 1.1 1.1 0 1.1-1.2 1.2c-1.2.1-1.2-.6-1.2-1.2zm2-8.2 1.8-.5v-5l-1.8-.5zm-1.8 0-1.8-.5v-5l1.8-.5z"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "M261.6 313.8q.4-1.5 1.9-2V306h1.7v5.7q1.4.5 1.8 1.7h4.7v.3h-6.3a1 1 0 0 0-1-.6 1 1 0 0 0-1.1.6h-1.7m13 0v-.3h4.4l.2-.4-5.4-6 1.3-1 5.3 5.8h.3v-8h1.7v7.9h.3l5.2-5.8 1.3 1-5.2 5.9.3.6h4.2v.3zm23 0a1 1 0 0 1 1.1-.6q.8 0 1 .6h1.7a3 3 0 0 0-1.8-2V306h-1.8v5.7a3 3 0 0 0-1.8 1.7h-4.6v.3zm-32.2-16 6.5 7.3 1.3-1-6.5-7.3.3-.6h4.7v-1.6H267a3 3 0 0 0-2.7-1.9 2.7 2.7 0 0 0-2.8 2.7q.1 1.8 1.9 2.5v5.6h1.7v-5.6zm34 .1v5.6h-1.7v-5.6l-.4-.2-6.3 7.4-1.3-1 6.5-7.5-.1-.3h-4.8v-1.6h4.8a3 3 0 0 1 2.6-1.9c1.6 0 2.8 1.2 2.8 2.7q-.1 2-2 2.5zm-17 0v3.4h-1.8V298a3 3 0 0 1-1.8-1.7h-4.3v-1.6h4.3a3 3 0 0 1 2.6-1.9q2 .1 2.7 1.9h4.3v1.6h-4.3a3 3 0 0 1-1.7 1.7zm-19 4.1-1.8.5v4.6l1.8.5V302m1.8 0 1.8.5v4.6l-1.8.5zm32.5 0-1.8.5v4.6l1.8.5zm1.8 0 1.8.5v4.6l-1.8.5zm-27.3 1 1.7-.8 3.2 3.5-1 1.5zm-1.3 1-1 1.5 3 3.5 1.8-.7zm19.7-1.2-1.8-.7-3 3.5 1 1.5zm1.3 1 1 1.6-3 3.5-1.8-.7 3.8-4.3m-21.7 9.6.5-1.7h4.8l.6 1.7zm-7-18.1q.1-1 1.1-1.2 1.1 0 1.2 1.2c.1 1.2-.5 1.1-1.2 1.1q-1-.1-1.2-1.1zm12.8.8-.5 1.7h-4.8l-.5-1.7zm0-1.7-.5-1.7h-4.8l-.5 1.7zm16.7 19-.5-1.7h-4.8l-.5 1.7zm4.6-18.1q.2-1 1.2-1.2 1.1 0 1.2 1.2c.1 1.2-.5 1.1-1.2 1.1q-1-.1-1.2-1.1m-17.2 0q.2-1 1.2-1.2c1-.2 1.2.5 1.2 1.2s-.5 1.1-1.2 1.1q-1-.1-1.2-1.1m6.7.8.6 1.7h4.8l.5-1.7zm0-1.6.5-1.8h4.9l.5 1.7H287m-6.3 5.4-1.8.5v4.6l1.8.5zm1.7 0 1.8.5v4.6l-1.8.5z"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#c8b100",
    strokeWidth: 0.3,
    d: "M284.2 337.3a17 17 0 0 0 4-1l.8 1.4a19 19 0 0 1-4.6 1.3 3 3 0 0 1-2.8 2 3 3 0 0 1-2.7-2 19 19 0 0 1-4.8-1.3l.8-1.5q2 1 4.2 1.1a3 3 0 0 1 1.6-1.4v-7.2h1.8v7.2a3 3 0 0 1 1.7 1.4zm-5-21.7-.2-.5h-4.4v-1.6h4.4q0-.3.2-.4l-5.4-6 1.3-1 5.3 5.8.3-.1V304h1.7v7.7l.3.1 5.2-5.9 1.3 1-5.2 6 .3.6h4.2v1.6h-4.2l-.3.6 5 5.6-1.4 1-4.9-5.6-.2.1v9.3h-1.8v-9.3l-.2-.1-5 5.6-1.4-1 5.1-5.7m-13.7-17.7 6.5 7.2 1.3-1-6.5-7.3.3-.6h4.7v-1.7h-4.7a3 3 0 0 0-2.7-1.8 2.7 2.7 0 0 0-2.8 2.7q.1 1.8 1.9 2.5v5.5h1.7V298h.3zm7 37-.9 1.5a18 18 0 0 1-3.9-3.3q-1.4.4-2.6-.5a2.5 2.5 0 0 1-.3-3.7v-.2a16 16 0 0 1-1.3-5.1h1.8a14 14 0 0 0 1.1 4.4l1.5.1 4.4-4.8 1.3 1-4.3 4.9a3 3 0 0 1-.1 3 16 16 0 0 0 3.3 2.7zm-9-14v-4a3 3 0 0 1-2-2.6q.2-1.9 2-2.6v-5.6h1.7v5.7q1.4.4 1.8 1.7h4.7v1.6H267a3 3 0 0 1-1.8 1.7v4.1h-1.7m2.5 9a1.2 1.2 0 0 1 1.7-.2q.7.7 0 1.6a1.3 1.3 0 0 1-1.6.1 1 1 0 0 1-.1-1.6zm-2.2-4.9-1.8-.4-.3-4.5 1.8-.6v2.6q0 1.5.3 3zm1.5-5.6 1.7.4.3 4.6-1.8.6-.3-2.9v-2.7zm5.9 14.6a17 17 0 0 0 5.1 2.7l.4-1.7a15 15 0 0 1-4.3-2.2l-1.2 1.2m-1 1.5a19 19 0 0 0 5.3 2.7l-1.4 1.2a20 20 0 0 1-4.2-2.1l.4-1.8"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#c8b100",
    strokeWidth: 0.3,
    d: "m272.6 325.4 1.7.8 3.2-3.5-1-1.5-3.9 4.2m-1.3-1-1-1.5 3.1-3.5 1.7.7-3.8 4.3m-8.2-10.1q.2-1.1 1.2-1.2 1.1 0 1.2 1.2 0 1-1.2 1.1-1-.1-1.2-1.1zm27.5 20.6.8 1.5a18 18 0 0 0 4-3.3q1.3.4 2.6-.5a2.5 2.5 0 0 0 .3-3.7l-.2-.2q1.1-2.4 1.4-5.1h-1.7a14 14 0 0 1-1.2 4.4l-1.5.1-4.3-4.8-1.4 1 4.4 4.9a3 3 0 0 0 .1 3 16 16 0 0 1-3.3 2.7zm9-14v-4.1a3 3 0 0 0 2-2.5 3 3 0 0 0-2-2.6v-5.6h-1.8v5.7q-1.3.4-1.8 1.7h-4.7v1.6h4.8a3 3 0 0 0 1.7 1.7v4.1zm-2.5 9a1.2 1.2 0 0 0-1.7-.2 1 1 0 0 0-.1 1.6q.7.8 1.7.1a1 1 0 0 0 0-1.6zm2.2-4.8 1.8-.4.2-4.6-1.7-.6v2.6zm-1.5-5.7-1.8.4v2.3c0-.8-.3 2.3-.3 2.3l1.9.6.2-2.9v-2.7m1.8-21.5v5.5h-1.8V298l-.4-.2-6.4 7.2-1.3-1.1 6.5-7.4-.1-.3h-4.8v-1.7h4.8a3 3 0 0 1 2.6-1.8c1.6 0 2.8 1.2 2.8 2.7q-.1 2-2 2.5zm-17.2 0v3.4h-1.7v-3.4a3 3 0 0 1-1.8-1.7h-4.3v-1.7h4.3a3 3 0 0 1 2.6-1.8q2 .2 2.7 1.8h4.3v1.7h-4.3a3 3 0 0 1-1.7 1.7zm9.5 36a17 17 0 0 1-5.2 2.8l-.4-1.7a15 15 0 0 0 4.3-2.1l1.3 1m.9 1.6a19 19 0 0 1-5.2 2.7l1.3 1.3a20 20 0 0 0 4.3-2.2l-.4-1.8M263.5 302l-1.8.5v4.6l1.8.5V302m1.8 0 1.8.5v4.6l-1.8.5V302m32.5 0-1.8.5v4.6l1.8.5V302"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#c8b100",
    strokeWidth: 0.3,
    d: "m299.6 302 1.8.5v4.6l-1.8.5V302m-9.2 23.4-1.7.8-3.1-3.5 1-1.5 3.8 4.2m1.3-1 1-1.5-3-3.5-1.8.7 3.8 4.3m-19.4-21.5 1.7-.7 3.1 3.5-1 1.5-3.8-4.3M271 304l-1 1.5 3 3.5 1.8-.8-3.8-4.2m19.7-1.2-1.8-.7-3 3.5 1 1.5 3.8-4.3m1.3 1 1 1.5-3 3.5-1.8-.7 3.8-4.2m-21.7 9.6.5-1.7h4.8l.6 1.7h-5.9m0 1.6.5 1.7h4.8l.6-1.7h-5.9m-7-19.7q.1-1.1 1.1-1.2 1.1 0 1.2 1.2c.1 1.2-.5 1.1-1.2 1.1q-1-.1-1.2-1.1zm12.8.8-.5 1.7h-4.8l-.5-1.7h5.8m0-1.7-.5-1.7h-4.8l-.5 1.7h5.8m21.4 19.8q0-1 1.2-1.2c1.2-.2 1.2.5 1.2 1.2q0 1-1.2 1.1c-1.2.1-1.2-.5-1.2-1.1zm-4.7-.8-.5-1.7h-4.8l-.5 1.7h5.9m0 1.6-.6 1.7h-4.8l-.5-1.7h5.9m-12.4 23.3q0-1 1.2-1.1 1 .1 1.1 1.1 0 1.1-1.2 1.2c-1.2.1-1.2-.5-1.2-1.2zm2-8.2 1.8-.5V325l-1.8-.5v5.6m-1.8 0-1.8-.5V325l1.8-.5v5.6m16.8-34.8q.2-1.1 1.2-1.2 1.1 0 1.2 1.2c.1 1.2-.5 1.1-1.2 1.1q-1-.1-1.2-1.1zm-17.2 0q.2-1.1 1.2-1.2 1.1 0 1.2 1.2c.1 1.2-.5 1.1-1.2 1.1q-1-.1-1.2-1.1zm6.7.8.6 1.7h4.8l.5-1.7H287m0-1.7.6-1.7h4.8l.5 1.7H287m-6.3 5.4-1.8.5v4.5l1.8.5V300m1.7 0 1.8.5v4.5l-1.8.5V300"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    fill: "#058e6e",
    d: "M278.8 314.3a2.7 2.7 0 0 1 2.8-2.6q2.6.2 2.8 2.6a2.7 2.7 0 0 1-2.8 2.7 2.7 2.7 0 0 1-2.8-2.7"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    fill: "#db4446",
    d: "M282.3 245v-.6l.1-.4s-1.6.2-2.5 0a6 6 0 0 1-2.5-1.4q-1-1-1.7-1.2c-1.4-.2-2.4.4-2.4.4s1 .4 1.8 1.4a5 5 0 0 0 2 1.5c.6.2 2.7 0 3.3.1z"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M282.3 245v-.6l.1-.4s-1.6.2-2.5 0a6 6 0 0 1-2.5-1.4q-1-1-1.7-1.2c-1.4-.2-2.4.4-2.4.4s1 .4 1.8 1.4a5 5 0 0 0 2 1.5c.6.2 2.7 0 3.3.1z"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    fill: "#ed72aa",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M290 242.7v1.4c.1.7-.2 1.3 0 1.7l.2 1c.2.2.3.9.3.9l-.8-.6-.6-.4v1q.2.6.6 1.3.6.6 1 1.4c.3.4.2 1.4.2 1.4s-.4-.7-.9-.9l-1.3-.6s.9.8.9 1.6c0 .7-.4 1.6-.4 1.6s-.3-.7-.8-1.1l-1.2-1s.5 1.2.5 2v2.6s-.5-.7-1-1l-1-.8c0-.2.5.7.6 1.2s.3 2.4 2 4.8c1 1.4 2.4 3.8 5.6 3s2-5 1.3-7-1-4.3-1-5c.1-.8.7-3 .6-3.5a9 9 0 0 1 .1-3.4q.6-1.8 1-2.4l.5-1.4v-1.4l.8 1.5.1 1.5s.1-1.1 1-1.7 2-1.2 2.2-1.5l.4-.5s-.1 2-.7 2.7l-1.8 2.2s.8-.3 1.3-.3h.9s-.7.5-1.5 1.6-.5 1.3-1 2.3c-.7 1-1.1 1-1.9 1.6-1 1-.5 4.5-.3 5 .1.5 2 4.9 2 6 .1 1 .3 3.3-1.6 4.9-1.2 1-3.1 1-3.6 1.2-.4.3-1.3 1.2-1.3 3s.7 2.1 1.2 2.6 1.2.2 1.3.5l.5.8q.4.3.3.8c0 .4-1 1.3-1.2 2-.3.6-1 2.2-1 2.5s0 1 .3 1.4c0 0 .9 1 .2 1.3-.4.1-.8-.3-1-.2l-1 .4q-.4 0-.4-.8l-.1-.7q-.4 0-.4.5c0 .2 0 .9-.3.9s-.6-.5-.9-.6c-.2 0-.8-.2-.9-.5q.1-.6.8-1 .8-.1.5-.5-.4-.3-.7 0-.6.3-.8-.3c-.2-.6.1-.7 0-.8 0-.2-.4-.6.2-.9s.8.3 1.4.2q1-.1 1.1-.7.4-.6-.2-1.5c-.6-.9-.8-.5-1-.8l-.3-1v2.4l-.8-.9c-.3-.3-.6-1.4-.6-1.4v1.4c0 .4.4.7.2.9-.1.1-.8-.8-1-.9q-.5-.3-1-1l-.6-1.5c0-.2-.2-1.4 0-1.6l.4-1.2h-1.4c-.8 0-1.3-.2-1.6.3q-.4.8.2 3 .6 2 .5 2.2l-.8 1-1-.1q-.2-.2-1.2-.3h-1.4c-.3 0-1-.4-1.2-.3q-.7 0-.7.7.1.9-.5.7l-1-.2c-.3-.1-.9 0-.8-.4q0-.5.4-.8.4-.5 0-.5h-.7q-.4.5-.7.5-.5-.2-.5-1.1c0-.7-.7-1.3 0-1.3s1.4.5 1.5.2q.2-.5-.3-.8c-.3-.3-.7-.5-.3-.8l.8-.6c.2-.1.4-.8.7-.6.7.3 0 .7.7 1.4s1 1 2.1.9q1.4-.1 1.4-.6l-.2-1 .2-1s-.5.3-.6.6l-.5.8v-2.1l-.2-.9-.3 1-.1 1s-.7-.5-.5-1.5v-2.1c.3-.4.9-1.7 2.2-1.8h2.8l2.1-.3s-3-1.5-3.7-2-1.8-1.7-2.1-2.2-.7-1.6-.7-1.6-.5 0-1 .3l-1.3 1-.7 1v-2s-.4 1.3-1 1.8l-1.5 1.2v-1l.2-1s-.5.8-1.2 1-1.9 0-2 .5q.1.9 0 1.4-.3.6-.5.6-.2-.2-.8-.4c-.6-.2-.7.2-.7.2s-.4-.4-.2-.7c0-.3.7-.7.5-.9q-.3 0-.9.2c-.3.2-.9.3-.8-.2q.2-.6 0-1-.1-.5.2-.6c.2-.1 1.2 0 1.3-.2q0-.4-.9-.7t-.6-.8l.6-.6c.1-.3.2-.8.7-.6.6.3.5.9 1 1 .6.3 2 0 2.3-.1l1.5-1 1.7-1.2-1.1-.8-1-1.1-2-.7c-.5 0-1.8-.5-1.8-.5l.8-.3q.4-.4.9-.6h.3-1.5c-.3-.2-1-.6-1.3-.6h-.9s.8-.4 1.4-.5l1.2-.1s-1-.3-1.3-.6l-.6-1q-.2-.5-.6-.6c-.4-.1-.9.4-1.2.3q-.4 0-.6-.7v-.5c-.2-.3-.7-.8-.2-1h1.4c.1-.2-.5-.7-.8-1-.4-.1-1-.4-.7-.7l.8-.6c.2-.3.4-1 .8-.7.3.2.9 1.3 1.1 1.2s.4-.9.3-1.2c0-.3 0-1 .3-.9s.5.5 1 .5 1.1-.1 1 .2q0 .6-.6 1.1a2 2 0 0 0-.2 1.6 4 4 0 0 0 1.2 1.5c.4.3 1.3.5 1.8.8s1.9 1.4 2.3 1.5l.9.3s.5-.2 1.1-.2 2.2.1 2.8-.1 1.3-.7 1.1-1.2-1.5-1-1.4-1.4q.2-.5 1.4-.5c.8 0 1.8.2 2-1 .2-1 .3-1.6-.8-1.9q-1.8-.1-2.1-1t-.2-1.3 1.5-.3 2-.3q.2-.4.6-1l1.5-.3s1.5.7 3 1.7c1.2 1 2.3 2.3 2.3 2.3"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "m279.3 242-.2-.7-.1-.3s.9 0 .9.2q-.1.4-.4.4-.1.3-.2.3"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "m279.3 242-.2-.7-.1-.3s.9 0 .9.2q-.1.4-.4.4-.1.3-.2.3z"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M283.4 240.5v-.5s.7 0 1.1.3c.6.4 1 1 1 1-.2.2-.6-.2-1-.3h-.4q-.3 0-.4-.2v-.3z"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M283.4 240.5v-.5s.7 0 1.1.3c.6.4 1 1 1 1-.2.2-.6-.2-1-.3h-.4q-.3 0-.4-.2v-.3z"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "m289 246.7-.4-.7-.2-.5"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    fill: "#db4446",
    d: "M267.9 241.8s.5.3.8.3l.9.1s.2-.5.1-1c-.2-1.2-1.3-1.4-1.3-1.4s.3.7.1 1q-.4 1-.6 1"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M267.9 241.8s.5.3.8.3l.9.1s.2-.5.1-1c-.2-1.2-1.3-1.4-1.3-1.4s.3.7.1 1q-.4 1-.6 1z"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    fill: "#db4446",
    d: "M265.5 242.8s-.4-.8-1.3-.7-1.6.9-1.6.9h1.3c.4.3.5 1 .5 1l.7-.6z"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M265.5 242.8s-.4-.8-1.3-.7-1.6.9-1.6.9h1.3c.4.3.5 1 .5 1l.7-.6z"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    fill: "#db4446",
    d: "M264.4 246s-.8.1-1.2.6c-.5.5-.4 1.5-.4 1.5s.5-.6 1-.6l1.2.2-.3-.9q-.2-.6-.3-.8"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M264.4 246s-.8.1-1.2.6c-.5.5-.4 1.5-.4 1.5s.5-.6 1-.6l1.2.2-.3-.9q-.2-.6-.3-.8z"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "m279.3 245.9.4-.5.3.5z"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "m279.3 245.9.4-.5.3.5h-.7"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "m280.2 245.9.4-.6.4.5z"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "m280.2 245.9.4-.6.4.5h-.8"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "m279.8 242.5.8.3-.7.4z"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "m279.8 242.5.8.3-.7.4-.1-.7"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "m280.8 242.8.8.2-.6.4z"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "m280.8 242.8.8.2-.6.4-.2-.6"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M275.2 249.2s-.9.3-1.2.7q-.4 1-.3 1.1c.1.1.7-.6 1.6-.3l1.3.3c.4 0 1.3-.4 1.3-.4s-.7.9-.6 1.5q.1.8.1 1.2c0 .7-.5 1.6-.5 1.6l1-.3a5 5 0 0 0 1.8-.9l1-1s-.2 1 0 1.5l.2 1.7s.4-.5.8-.7c.2 0 .8-.4 1-.7l.3-1s0 .8.4 1.3c.3.4.7 1.8.7 1.8s.3-.9.6-1.3q.6-.6.7-1v-1l.4 1m-11.7.6s.5-.9 1-1.2l1.2-.8 1-.4m1 5.3 1.4-.8 1.2-1.2"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    fill: "#db4446",
    d: "M267 256.4s-.4-.5-1.2-.3c-.7 0-1.2 1-1.2 1l1-.2q.6.4.6.5l.5-.4z"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M267 256.4s-.4-.5-1.2-.3c-.7 0-1.2 1-1.2 1l1-.2q.6.4.6.5l.5-.4z"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    fill: "#db4446",
    d: "M266.2 259.4s-.7 0-1.2.4-.6 1.2-.6 1.2.5-.4 1-.3l.8.2.1-.6q0-.7-.1-.9"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M266.2 259.4s-.7 0-1.2.4-.6 1.2-.6 1.2.5-.4 1-.3l.8.2.1-.6q0-.7-.1-.9z"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    fill: "#db4446",
    d: "M267.6 262.2s0 .8.4 1.3 1.2.6 1.2.6l-.3-.8c-.1-.4.3-.7.3-.7s-.4-.4-.7-.4z"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M267.6 262.2s0 .8.4 1.3 1.2.6 1.2.6l-.3-.8c-.1-.4.3-.7.3-.7s-.4-.4-.7-.4zm17.1 1.4s2.1 1.3 2 2.4c0 1-1.1 2.4-1.1 2.4"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    fill: "#db4446",
    d: "M275.2 269.4s-.5-.6-1.3-.6c-.7 0-1.5.7-1.5.7s1 0 1.2.2l.4.7.6-.3z"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M275.2 269.4s-.5-.6-1.3-.6c-.7 0-1.5.7-1.5.7s1 0 1.2.2l.4.7.6-.3z"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    fill: "#db4446",
    d: "M273 272.3s-1-.1-1.5.4-.4 1.4-.4 1.4.6-.7 1-.6q1 .1 1.2.3l-.2-.8z"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M273 272.3s-1-.1-1.5.4-.4 1.4-.4 1.4.6-.7 1-.6q1 .1 1.2.3l-.2-.8z"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    fill: "#db4446",
    d: "M275 275.4s-.5.6-.1 1.1c.3.6 1 .8 1 .8s-.2-.4-.1-.8.7-.8.7-.8z"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M275 275.4s-.5.6-.1 1.1c.3.6 1 .8 1 .8s-.2-.4-.1-.8.7-.8.7-.8z"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    fill: "#db4446",
    d: "M287.7 276.6s-.8-.2-1.3 0-.8 1.5-.8 1.5.7-.6 1.3-.6l1 .3v-.8z"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M287.7 276.6s-.8-.2-1.3 0-.8 1.5-.8 1.5.7-.6 1.3-.6l1 .3v-.8z"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    fill: "#db4446",
    d: "M288.1 279.7s-.6.6-.4 1.2l.6 1s0-.7.3-1 1-.3 1-.3l-.7-.6z"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M288.1 279.7s-.6.6-.4 1.2l.6 1s0-.7.3-1 1-.3 1-.3l-.7-.6z"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    fill: "#db4446",
    d: "M291.3 280.6s-.3.8.3 1.3q1 .8 1.1.6c.1-.2-.5-.8-.3-1.3q.3-.6.5-.7l-.8-.2z"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M291.3 280.6s-.3.8.3 1.3q1 .8 1.1.6c.1-.2-.5-.8-.3-1.3q.3-.6.5-.7l-.8-.2z"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffd691",
    stroke: "#000",
    strokeWidth: 0.5,
    d: "M258.7 337.5q3.2 1.1 3.2 4c0 2.5-2.3 4.3-5.4 4.3-3 0-5.6-1.8-5.6-4.2 0-1.9 1-4 3.2-4l-.3-.6-.6-.7h1.3l.7.5.6-.7q.6-.6.7-.6l.6.7.3.6s.4-.4.8-.5l.9-.3-.3.7-.1.8"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    fill: "#058e6e",
    stroke: "#000",
    strokeWidth: 0.5,
    d: "M256 348.5s-4-2.8-5.8-3.1c-2.3-.5-4.8-.1-5.9-.2l1.9 1.5a11 11 0 0 0 3.5 2c3.3.8 6.3-.2 6.3-.2m1.2.2s2.6-2.7 5.3-3c3.3-.5 5.4.2 6.6.5 0 0-1 .5-1.6 1-.5.3-2 1.5-4.2 1.6-2.2 0-4.7-.3-5.1-.2l-1 .1"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    fill: "#ad1519",
    stroke: "#000",
    strokeWidth: 0.5,
    d: "M256.4 345.4a5.2 5.2 0 0 1 0-7.6 5 5 0 0 1 1.7 3.8 5 5 0 0 1-1.7 3.8"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    fill: "#058e6e",
    stroke: "#000",
    strokeWidth: 0.5,
    d: "M255.4 351s.6-1.6.7-3l-.2-2.2h.8s.4 1.2.4 2.2l-.2 2.5-.7.1-.8.3"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M307 203.4q0-1 1-1 1.1 0 1.2 1c.1 1-.5 1.1-1.2 1.1a1 1 0 0 1-1-1"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M307 203.4q0-1 1-1 1.1 0 1.2 1c.1 1-.5 1.1-1.2 1.1a1 1 0 0 1-1-1z"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M308.4 200.7q.2-1 1.2-1a1 1 0 0 1 1 1q0 1-1 1a1 1 0 0 1-1.2-1"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M308.4 200.7q.2-1 1.2-1a1 1 0 0 1 1 1q0 1-1 1a1 1 0 0 1-1.2-1z"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M309.5 197.6q.1-1 1-1a1 1 0 0 1 1.2 1q-.1 1-1.1 1a1 1 0 0 1-1.1-1"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M309.5 197.6q.1-1 1-1a1 1 0 0 1 1.2 1q-.1 1-1.1 1a1 1 0 0 1-1.1-1z"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M309.6 194.2q.1-1 1.1-1a1 1 0 0 1 1.1 1q-.1 1-1 1-1.1 0-1.2-1"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M309.6 194.2q.1-1 1.1-1a1 1 0 0 1 1.1 1q-.1 1-1 1-1.1 0-1.2-1z"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M308.8 190.9q.1-1 1-1a1 1 0 0 1 1.2 1q-.1 1-1.1 1a1 1 0 0 1-1.1-1"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M308.8 190.9q.1-1 1-1a1 1 0 0 1 1.2 1q-.1 1-1.1 1a1 1 0 0 1-1.1-1z"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M307 187.8q0-.9 1.2-1a1 1 0 0 1 1 1q0 1-1 1.1a1 1 0 0 1-1.2-1"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M307 187.8q0-.9 1.2-1a1 1 0 0 1 1 1q0 1-1 1.1a1 1 0 0 1-1.2-1z"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M304.7 185.4q0-1 1.2-1a1 1 0 0 1 1 1q0 .9-1 1a1 1 0 0 1-1.2-1"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M304.7 185.4q0-1 1.2-1a1 1 0 0 1 1 1q0 .9-1 1a1 1 0 0 1-1.2-1z"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M302 183.3q.2-1 1.2-1 1.3 0 1.1 1c-.2 1-.5 1-1.1 1a1 1 0 0 1-1.1-1"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M302 183.3q.2-1 1.2-1 1.3 0 1.1 1c-.2 1-.5 1-1.1 1a1 1 0 0 1-1.1-1z"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M298.9 181.6q.1-1 1-1 1.1 0 1.2 1c.1 1-.5 1-1.1 1a1 1 0 0 1-1.1-1"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M298.9 181.6q.1-1 1-1 1.1 0 1.2 1c.1 1-.5 1-1.1 1a1 1 0 0 1-1.1-1z"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M295.5 180.4q0-1 1.2-1a1 1 0 0 1 1 1q0 1-1 1a1 1 0 0 1-1.2-1"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M295.5 180.4q0-1 1.2-1a1 1 0 0 1 1 1q0 1-1 1a1 1 0 0 1-1.2-1z"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M291.8 179.8q.1-1 1.1-1.1 1.1.1 1.2 1t-1.2 1.1a1 1 0 0 1-1-1"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M291.8 179.8q.1-1 1.1-1.1 1.1.1 1.2 1t-1.2 1.1a1 1 0 0 1-1-1z"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M288.3 179.6q.1-1 1.1-1a1 1 0 0 1 1.2 1q0 1-1.2 1a1 1 0 0 1-1-1"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M288.3 179.6q.1-1 1.1-1a1 1 0 0 1 1.2 1q0 1-1.2 1a1 1 0 0 1-1-1z"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M284.9 179.7q.1-1 1-1 1.1 0 1.2 1c.1 1-.5 1-1.1 1a1 1 0 0 1-1.1-1"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M284.9 179.7q.1-1 1-1 1.1 0 1.2 1c.1 1-.5 1-1.1 1a1 1 0 0 1-1.1-1z"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M281.4 179.7q.1-1 1.1-1t1.1 1c.1 1-.5 1-1 1a1 1 0 0 1-1.2-1"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M281.4 179.7q.1-1 1.1-1t1.1 1c.1 1-.5 1-1 1a1 1 0 0 1-1.2-1z"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M283.1 182.7q.1-1 1.1-1.1 1.1.1 1.2 1-.1 1-1.1 1.1a1 1 0 0 1-1.2-1m.7 3.2q0-1 1.2-1 1 0 1 1c0 1-.4 1-1 1a1 1 0 0 1-1.2-1m.2 3.3q.1-1 1-1a1 1 0 0 1 1.2 1q-.1 1-1.1 1a1 1 0 0 1-1.1-1m-1 3q0-1 1-1.1a1 1 0 0 1 1.2 1q-.1 1-1.1 1.1a1 1 0 0 1-1.2-1m-1.9 2.7q0-1 1.2-1 1 0 1 1c0 1-.4 1-1 1a1 1 0 0 1-1.2-1"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M278.8 177.6q.1-.9 1.1-1t1.1 1c.1 1-.5 1.1-1 1.1a1 1 0 0 1-1.2-1"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M278.8 177.6q.1-.9 1.1-1t1.1 1c.1 1-.5 1.1-1 1.1a1 1 0 0 1-1.2-1z"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M275.7 176q.1-1 1.1-1.1 1.1 0 1.2 1c.1 1-.5 1.1-1.1 1.1a1 1 0 0 1-1.2-1"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M275.7 176q.1-1 1.1-1.1 1.1 0 1.2 1c.1 1-.5 1.1-1.1 1.1a1 1 0 0 1-1.2-1z"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M272.3 175q0-1 1.2-1.1 1 0 1 1c0 1-.4 1-1 1a1 1 0 0 1-1.2-1"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M272.3 175q0-1 1.2-1.1 1 0 1 1c0 1-.4 1-1 1a1 1 0 0 1-1.2-1z"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M268.8 174.3q.1-1 1.1-1 1.1 0 1.2 1c.1 1-.5 1-1.2 1a1 1 0 0 1-1-1"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M268.8 174.3q.1-1 1.1-1 1.1 0 1.2 1c.1 1-.5 1-1.2 1a1 1 0 0 1-1-1z"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M265.4 174.4q.1-1 1.1-1t1.1 1c.1 1-.5 1-1.1 1a1 1 0 0 1-1.1-1"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M265.4 174.4q.1-1 1.1-1t1.1 1c.1 1-.5 1-1.1 1a1 1 0 0 1-1.1-1z"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M261.8 175q.1-1 1.1-1a1 1 0 0 1 1.1 1q-.1 1-1 1a1 1 0 0 1-1.2-1"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M261.8 175q.1-1 1.1-1a1 1 0 0 1 1.1 1q-.1 1-1 1a1 1 0 0 1-1.2-1z"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M258.5 176.1q.1-1 1.1-1t1.1 1c.1 1-.5 1-1.1 1a1 1 0 0 1-1.1-1"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M258.5 176.1q.1-1 1.1-1t1.1 1c.1 1-.5 1-1.1 1a1 1 0 0 1-1.1-1z"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M202.3 203.4q.1-1 1.1-1a1 1 0 0 1 1.1 1q-.1 1-1 1.1a1 1 0 0 1-1.2-1"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M202.3 203.4q.1-1 1.1-1a1 1 0 0 1 1.1 1q-.1 1-1 1.1a1 1 0 0 1-1.2-1z"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M200.8 200.7q.1-1 1-1 1.1 0 1.2 1c.1 1-.5 1-1.1 1a1 1 0 0 1-1.1-1"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M200.8 200.7q.1-1 1-1 1.1 0 1.2 1c.1 1-.5 1-1.1 1a1 1 0 0 1-1.1-1z"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M199.7 197.6q0-1 1.2-1a1 1 0 0 1 1 1q0 1-1 1a1 1 0 0 1-1.2-1"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M199.7 197.6q0-1 1.2-1a1 1 0 0 1 1 1q0 1-1 1a1 1 0 0 1-1.2-1z"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M199.6 194.2q.1-1 1.1-1 1.1 0 1.2 1c.1 1-.5 1-1.2 1q-1 0-1-1"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M199.6 194.2q.1-1 1.1-1 1.1 0 1.2 1c.1 1-.5 1-1.2 1q-1 0-1-1z"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M200.4 190.9q0-1 1.2-1 1 0 1 1c0 1-.4 1-1 1a1 1 0 0 1-1.2-1"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M200.4 190.9q0-1 1.2-1 1 0 1 1c0 1-.4 1-1 1a1 1 0 0 1-1.2-1z"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M202.2 187.8q.1-.9 1-1a1 1 0 0 1 1.2 1q-.1 1-1.1 1.1a1 1 0 0 1-1.1-1"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M202.2 187.8q.1-.9 1-1a1 1 0 0 1 1.2 1q-.1 1-1.1 1.1a1 1 0 0 1-1.1-1z"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M204.5 185.4q.1-1 1.1-1t1.1 1q-.1.9-1.1 1t-1.1-1"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M204.5 185.4q.1-1 1.1-1t1.1 1q-.1.9-1.1 1t-1.1-1z"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M207.2 183.3q.1-1 1-1 1.1 0 1.2 1c.1 1-.5 1-1.1 1a1 1 0 0 1-1.2-1"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M207.2 183.3q.1-1 1-1 1.1 0 1.2 1c.1 1-.5 1-1.1 1a1 1 0 0 1-1.2-1z"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M210.3 181.6q0-1 1.2-1a1 1 0 0 1 1 1q0 1-1 1a1 1 0 0 1-1.2-1"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M210.3 181.6q0-1 1.2-1a1 1 0 0 1 1 1q0 1-1 1a1 1 0 0 1-1.2-1z"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M213.7 180.4q.1-1 1-1 1.1 0 1.2 1c.1 1-.5 1-1.1 1a1 1 0 0 1-1.1-1"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M213.7 180.4q.1-1 1-1 1.1 0 1.2 1c.1 1-.5 1-1.1 1a1 1 0 0 1-1.1-1z"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M217.4 179.8q.1-1 1.1-1.1a1 1 0 0 1 1.1 1q-.1 1-1.1 1.1a1 1 0 0 1-1.1-1"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M217.4 179.8q.1-1 1.1-1.1a1 1 0 0 1 1.1 1q-.1 1-1.1 1.1a1 1 0 0 1-1.1-1z"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M220.9 179.6q.1-1 1.1-1t1.1 1c.1 1-.5 1-1 1a1 1 0 0 1-1.2-1"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M220.9 179.6q.1-1 1.1-1t1.1 1c.1 1-.5 1-1 1a1 1 0 0 1-1.2-1z"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M224.3 179.7q0-1 1.2-1a1 1 0 0 1 1 1q0 1-1 1a1 1 0 0 1-1.2-1"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M224.3 179.7q0-1 1.2-1a1 1 0 0 1 1 1q0 1-1 1a1 1 0 0 1-1.2-1z"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M227.8 179.7q.1-1 1.1-1t1.2 1c.2 1-.5 1-1.2 1a1 1 0 0 1-1.1-1"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M227.8 179.7q.1-1 1.1-1t1.2 1c.2 1-.5 1-1.2 1a1 1 0 0 1-1.1-1z"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M226 182.7q.1-1 1.2-1.1c1.1-.1 1.1.5 1.1 1q-.1 1-1.1 1.1a1 1 0 0 1-1.1-1m-.7 3.2q.1-1 1-1 1.1 0 1.2 1c.1 1-.5 1-1.1 1q-1 0-1.1-1m-.2 3.3q0-1 1.2-1 1 0 1 1c0 1-.4 1-1 1a1 1 0 0 1-1.2-1m1 3q.2-1 1.2-1.1a1 1 0 0 1 1.1 1q-.1 1-1.1 1.1a1 1 0 0 1-1.1-1m1.9 2.7q.1-1 1-1 1.1 0 1.2 1c.1 1-.5 1-1.1 1a1 1 0 0 1-1.1-1"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M230.4 177.6q.1-.9 1.1-1 1.1 0 1.2 1c.1 1-.5 1.1-1.2 1.1a1 1 0 0 1-1-1"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M230.4 177.6q.1-.9 1.1-1 1.1 0 1.2 1c.1 1-.5 1.1-1.2 1.1a1 1 0 0 1-1-1z"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M233.5 176q.1-1 1.1-1.1 1 0 1.1 1c.1 1-.5 1.1-1 1.1a1 1 0 0 1-1.2-1"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M233.5 176q.1-1 1.1-1.1 1 0 1.1 1c.1 1-.5 1.1-1 1.1a1 1 0 0 1-1.2-1z"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M236.9 175q.1-1 1-1.1 1.3 0 1.2 1c-.1 1-.5 1-1.1 1a1 1 0 0 1-1.1-1"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M236.9 175q.1-1 1-1.1 1.3 0 1.2 1c-.1 1-.5 1-1.1 1a1 1 0 0 1-1.1-1z"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M240.4 174.3q.1-1 1.1-1a1 1 0 0 1 1.1 1q-.1 1-1 1a1 1 0 0 1-1.2-1"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M240.4 174.3q.1-1 1.1-1a1 1 0 0 1 1.1 1q-.1 1-1 1a1 1 0 0 1-1.2-1z"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M243.8 174.4q0-1 1.2-1a1 1 0 0 1 1 1q0 1-1 1a1 1 0 0 1-1.2-1"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M243.8 174.4q0-1 1.2-1a1 1 0 0 1 1 1q0 1-1 1a1 1 0 0 1-1.2-1z"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M247.4 175q.1-1 1.1-1a1 1 0 0 1 1.2 1q0 1-1.2 1a1 1 0 0 1-1-1"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M247.4 175q.1-1 1.1-1a1 1 0 0 1 1.2 1q0 1-1.2 1a1 1 0 0 1-1-1z"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M250.7 176.1q0-1 1.2-1 1 0 1 1c0 1-.4 1-1 1a1 1 0 0 1-1.2-1"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M250.7 176.1q0-1 1.2-1 1 0 1 1c0 1-.4 1-1 1a1 1 0 0 1-1.2-1z"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    stroke: "#000",
    strokeWidth: 0.5,
    d: "M222.3 244.1h-1v-1h-1.6v3.9h1.6v2.6h-3.5v7.5h1.9v15.2h-3.8v7.8h29v-7.8h-3.7v-15.2h1.9v-7.5h-3.6V247h1.7v-3.8h-1.7v1h-1v-1H237v1h-1.2v-1h-1.6v3.8h1.6v2.6h-3.5v-8.3h1.9v-3.8h-1.9v1h-1v-1h-1.6v1h-1v-1h-1.9v3.8h2v8.3H225V247h1.7v-3.8H225v1h-1v-1h-1.8v1zm-6.4 36h29m-29-1.9h29m-29-1.9h29m-29-1.9h29m-29-2.1h29m-25.2-1.7h21.5m-21.5-1.9h21.5m-21.5-2h21.5m-21.5-2h21.5m-21.5-1.9h21.5m-21.5-1.9h21.5m-21.5-1.9h21.5m-23.4-1.9H243m-25.3-1.8H243m-25.3-2H243m-25.3-1.8H243m-21.8-2h18.2m-10.9-1.8h3.6m-3.5-2h3.5m-3.5-1.8h3.5m-3.5-1.9h3.5m-5.4-2.4h7.3m-12.8 8h3.8m-5.4-2.3h7m-7 34.8v-1.9m0-1.9v-1.9m-2 2v1.8m3.6 0v-1.9m2 3.8v-1.9m0-1.9v-1.9m0-2.1v-1.7m0-1.9v-2m-2 7.7v-2.1m-3.5 2.1v-2.1m7.3 0v2.1m1.7-2.1v-1.7m-5.5-1.9v2m3.8-2v2m3.5-2v2m-1.8-2v-2m1.8-2v2m0-5.8v2m-1.8-3.9v2m1.8-3.8v1.8m-3.5-1.9v2m-3.8-2v2m-1.6-3.8v1.9m3.5-2v2m3.6-2v2m1.9-3.8v1.9m-3.6-2v2m-3.8-2v2m-1.6-3.8v1.9m7-2v2m-3.5-5.7v1.9m16.3-2h-3.7m5.4-2.3H234m7 34.8v-1.9m0-1.9v-1.9m2 2v1.8m-3.6 0v-1.9m-1.9 3.8v-1.9m0-1.9v-1.9m0-2.1v-1.7m0-1.9v-2m2 7.7v-2.1m3.5 2.1v-2.1m-7.3 0v2.1m-1.7-2.1v-1.7m5.4-1.9v2m-3.7-2v2m-3.6-2v2m1.9-2v-2m-1.9-2v2m0-5.8v2m1.9-3.9v2m-1.9-3.8v1.8m3.6-1.9v2m3.8-2v2m1.6-3.8v1.9m-3.5-2v2m-3.6-2v2m-1.9-3.8v1.9m3.6-2v2m3.7-2v2m1.7-3.8v1.9m-7.1-2v2m3.6-5.7v1.9m-7.4 19.1v-2m0-5.8V259m0 5.7v-1.9m0-5.7v-1.8m0-2v-1.8m0-3.8v-2m0-1.8V242m-9 5h3.8m3.6-5.7h3.5m3.6 5.7h3.7"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    stroke: "#000",
    strokeWidth: 0.5,
    d: "M235.3 280.1v-5c0-1-.5-3.8-5-3.8-4.3 0-4.7 2.9-4.7 3.8v5z"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    stroke: "#000",
    strokeWidth: 0.5,
    d: "m227.2 275.4-2.3-.3c0-1 .2-2.3 1-2.8l2 1.7c-.2.2-.7.9-.7 1.4zm6.4 0 2.4-.3c0-1-.3-2.3-1-2.8l-2 1.7c.1.2.6.9.6 1.4zm-2.4-2.4 1.2-2.1-2-.5q-1 0-2 .5l1.2 2.1zm-4.4-6v-5c0-1.4-1-2.6-2.6-2.6s-2.6 1.2-2.6 2.6v5.2h5.2zm7.3 0v-5c0-1.4 1-2.6 2.6-2.6s2.6 1.2 2.6 2.6v5.2h-5.2zm-1.9-12.7.5-4.7h-4.5l.2 4.7zm3.5 0-.4-4.7h4.7l-.5 4.7zm-10.6 0 .2-4.7h-4.5l.5 4.7z"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    fill: "#0039f0",
    d: "M233.6 280.1v-4.3c0-.7-.4-2.8-3.3-2.8a3 3 0 0 0-3 2.8v4.3zm-7.3-13.5v-4.5c0-1.2-.7-2.4-2.1-2.4s-2.2 1.2-2.2 2.4v4.5zm8.3 0v-4.5c0-1.2.7-2.4 2.1-2.4s2.1 1.2 2.1 2.4v4.5z"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    fill: "#ad1519",
    d: "M239.5 287.8c0-10.4 7.5-18.8 16.6-18.8s16.7 8.4 16.7 18.7c0 10.4-7.5 18.8-16.7 18.8s-16.6-8.4-16.6-18.7"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.6,
    d: "M239.5 287.8c0-10.4 7.5-18.8 16.6-18.8s16.7 8.4 16.7 18.7c0 10.4-7.5 18.8-16.7 18.8s-16.6-8.4-16.6-18.7z"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    fill: "#005bbf",
    d: "M244.4 287.7c0-7.6 5.3-13.7 11.7-13.7 6.5 0 11.8 6.1 11.8 13.7s-5.3 13.7-11.7 13.7c-6.5 0-11.8-6.1-11.8-13.7"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.6,
    d: "M244.4 287.7c0-7.6 5.3-13.7 11.7-13.7 6.5 0 11.8 6.1 11.8 13.7s-5.3 13.7-11.7 13.7c-6.5 0-11.8-6.1-11.8-13.7z"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "M250.6 278.3s-1.4 1.5-1.4 2.9.6 2.6.6 2.6a2 2 0 0 0-1.4-1 1.5 1.5 0 0 0-1.6 1.5l.3.8.5 1q.3-.6 1-.6 1 .1 1 1v.3h-1.2v1h1.1l-.8 1.7 1-.4 1 1 .8-1 1 .4-.7-1.6h1v-1.1h-1.2v-.3q.1-.9 1-1 1.2 0 1 .6l.6-1 .2-.8q0-1.4-1.5-1.5-1 0-1.4 1s.5-1.2.5-2.6-1.4-3-1.4-3"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.3,
    d: "M250.6 278.3s-1.4 1.5-1.4 2.9.6 2.6.6 2.6a2 2 0 0 0-1.4-1 1.5 1.5 0 0 0-1.6 1.5l.3.8.5 1q.3-.6 1-.6 1 .1 1 1v.3h-1.2v1h1.1l-.8 1.7 1-.4 1 1 .8-1 1 .4-.7-1.6h1v-1.1h-1.2v-.3q.1-.9 1-1 1.2 0 1 .6l.6-1 .2-.8q0-1.4-1.5-1.5-1 0-1.4 1s.5-1.2.5-2.6-1.4-3-1.4-3z"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "M248.4 287.9h4.5v-1.1h-4.5v1z"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M248.4 287.9h4.5v-1.1h-4.5v1z"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "M261.5 278.3s-1.4 1.5-1.4 2.9.6 2.6.6 2.6q-.4-1-1.4-1-1.5.2-1.6 1.5l.3.8.5 1q.2-.6 1-.6a1 1 0 0 1 1 1v.3h-1.2v1h1.1l-.8 1.7 1-.4.9 1 .9-1 1 .4-.8-1.6h1.1v-1.1h-1.2v-.3q.1-.9 1-1c.9-.1.9.2 1 .6l.6-1 .2-.8q-.1-1.4-1.5-1.5-1.1 0-1.5 1s.6-1.2.6-2.6-1.4-3-1.4-3"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.3,
    d: "M261.5 278.3s-1.4 1.5-1.4 2.9.6 2.6.6 2.6q-.4-1-1.4-1-1.5.2-1.6 1.5l.3.8.5 1q.2-.6 1-.6a1 1 0 0 1 1 1v.3h-1.2v1h1.1l-.8 1.7 1-.4.9 1 .9-1 1 .4-.8-1.6h1.1v-1.1h-1.2v-.3q.1-.9 1-1c.9-.1.9.2 1 .6l.6-1 .2-.8q-.1-1.4-1.5-1.5-1.1 0-1.5 1s.6-1.2.6-2.6-1.4-3-1.4-3z"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "M259.3 287.9h4.5v-1.1h-4.5v1z"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M259.3 287.9h4.5v-1.1h-4.5v1z"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "M256 287.6s-1.3 1.5-1.3 3c0 1.4.6 2.6.6 2.6a2 2 0 0 0-1.5-1 1.5 1.5 0 0 0-1.5 1.4l.2.8.5 1q.3-.5 1-.5 1 0 1.1 1v.3h-1.2v1h1l-.8 1.7 1.1-.5.9 1 .8-1 1.1.5-.8-1.7h1.1v-1h-1.2v-.3q0-1 1-1 .8 0 1 .5l.5-1q.2-.3.3-.8-.1-1.3-1.6-1.4a2 2 0 0 0-1.4 1s.6-1.2.6-2.7c0-1.4-1.4-2.9-1.4-2.9"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.3,
    d: "M256 287.6s-1.3 1.5-1.3 3c0 1.4.6 2.6.6 2.6a2 2 0 0 0-1.5-1 1.5 1.5 0 0 0-1.5 1.4l.2.8.5 1q.3-.5 1-.5 1 0 1.1 1v.3h-1.2v1h1l-.8 1.7 1.1-.5.9 1 .8-1 1.1.5-.8-1.7h1.1v-1h-1.2v-.3q0-1 1-1 .8 0 1 .5l.5-1q.2-.3.3-.8-.1-1.3-1.6-1.4a2 2 0 0 0-1.4 1s.6-1.2.6-2.7c0-1.4-1.4-2.9-1.4-2.9z"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "M253.8 297.2h4.5v-1h-4.5z"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M253.8 297.2h4.5v-1h-4.5z"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "M289.4 238.3h-.3l-.3.4q-.5.4-.9 0l-.1-.4h-.5q-.5-.2-.2-.8l.1-.2v-.3h-.3l-.1.3q-.5.4-.8.1l-.1-.2h-.2c-.5.2-.7-1-.8-1.3l-.1.3v1.3l-.3 1.2q1.4.3 3 1.7a10 10 0 0 1 2.5 2.5l1.2-.6c.6-.2 1.4-.2 1.4-.2l.2-.2c-.3 0-1.6.1-1.6-.4l.1-.2h-.3q-.3-.3 0-.8h.2v-.4h-.3l-.2.1q-.5.5-.9 0v-.4h-.6a1 1 0 0 1 0-.9l.2-.3z"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M289.4 238.3h-.3l-.3.4q-.5.4-.9 0l-.1-.4h-.5q-.5-.2-.2-.8l.1-.2v-.3h-.3l-.1.3q-.5.4-.8.1l-.1-.2h-.2c-.5.2-.7-1-.8-1.3l-.1.3v1.3l-.3 1.2q1.4.3 3 1.7a10 10 0 0 1 2.5 2.5l1.2-.6c.6-.2 1.4-.2 1.4-.2l.2-.2c-.3 0-1.6.1-1.6-.4l.1-.2h-.3q-.3-.3 0-.8h.2v-.4h-.3l-.2.1q-.5.5-.9 0v-.4h-.6a1 1 0 0 1 0-.9l.2-.3z"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    d: "M287 239h.3s.1.2 0 .2h-.2v-.2"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M287 239h.3s.1.2 0 .2h-.2v-.2z"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    d: "m288 239.8-.3-.2v-.2h.2l.3.3.3.2s.1.1 0 .2h-.1z"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m288 239.8-.3-.2v-.2h.2l.3.3.3.2s.1.1 0 .2h-.1l-.4-.3"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    d: "m286.3 238.6-.3-.2s-.1 0 0-.1h.1l.3.1.2.2.1.1h-.2z"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m286.3 238.6-.3-.2s-.1 0 0-.1h.1l.3.1.2.2.1.1h-.2l-.2-.1"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    d: "M285.2 237.9h.2l.1.2h-.2z"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M285.2 237.9h.2l.1.2h-.2z"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    d: "M289.1 240.6v-.3h-.3v.3z"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M289.1 240.6v-.3h-.3v.3z"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    d: "m289.7 241.2.2.2q.1.1.2 0l-.2-.3-.2-.2h-.2v.1z"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m289.7 241.2.2.2q.1.1.2 0l-.2-.3-.2-.2h-.2v.1l.2.2"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    d: "M290.7 242v-.2h-.3v.3h.3"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M290.7 242v-.2h-.3v.3h.3z"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "M287.9 235.9h-.6l-.2.9.1.1h.2l.7-.5z"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M287.9 235.9h-.6l-.2.9.1.1h.2l.7-.5-.2-.5"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "M286.2 236.4v.5l1 .2v-.3l-.5-.7z"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M286.2 236.4v.5l1 .2v-.3l-.5-.7-.5.3"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "m288.2 237.5-.5.3-.6-.8v-.1h1.1z"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "m288.2 237.5-.5.3-.6-.8v-.1h1.1v.6"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "m287 236.8.3-.1.1.4h-.3z"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "m287 236.8.3-.1.1.4h-.3z"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "m284.8 235.9-.3-.8-.4-.4s.4-.2.9.1 0 .9 0 .9z"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "m284.8 235.9-.3-.8-.4-.4s.4-.2.9.1 0 .9 0 .9z"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "m285.8 236.2-.4.4-.7-.6v-.3h1z"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "m285.8 236.2-.4.4-.7-.6v-.3h1l.1.5"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "m284.6 235.8.3-.2q.2 0 .1.3 0 .3-.3.3v-.4"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "m284.6 235.8.3-.2q.2 0 .1.3 0 .3-.3.3v-.4z"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "M290.2 237.3h-.6l-.3.8v.2h.2l.9-.4z"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M290.2 237.3h-.6l-.3.8v.2h.2l.9-.4-.2-.6"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "m288.5 237.6-.1.6.9.2h.1v-.2l-.4-.8z"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "m288.5 237.6-.1.6.9.2h.1v-.2l-.4-.8-.5.2"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "m290.3 239-.6.2-.4-.8v-.2h.1l1 .2z"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "m290.3 239-.6.2-.4-.8v-.2h.1l1 .2-.1.6"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "M289.1 238.1q.2-.2.4 0l.1.4h-.4v-.4"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M289.1 238.1q.2-.2.4 0l.1.4h-.4v-.4z"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "m292.2 239.2.1.6-.9.3h-.1v-.2l.3-.8z"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "m292.2 239.2.1.6-.9.3h-.1v-.2l.3-.8.6.1"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "m292 240.8-.5.2-.3-.9v-.1h.2l.8.3z"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "m292 240.8-.5.2-.3-.9v-.1h.2l.8.3-.1.5"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "m290.5 239.3-.2.5.9.3h.1v-.1l-.2-.9z"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "m290.5 239.3-.2.5.9.3h.1v-.1l-.2-.9-.6.2"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "M291.5 240.3v-.4a.3.3 0 0 0-.5 0v.3h.4"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M291.5 240.3v-.4a.3.3 0 0 0-.5 0v.3h.4z"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "m292.9 242.1.8.1.5.3s.1-.5-.3-.8-.9.2-.9.2z"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "m292.9 242.1.8.1.5.3s.1-.5-.3-.8-.9.2-.9.2z"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "m292.3 241.2-.3.5.8.5v-.1h.2l-.1-1z"
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "m292.3 241.2-.3.5.8.5v-.1h.2l-.1-1h-.6"
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8b100",
    d: "M293 242.2s.2-.2.1-.3h-.4q-.2 0-.1.3z"
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M293 242.2s.2-.2.1-.3h-.4q-.2 0-.1.3zm40.7-23.4v.6H331v-.6h1v-1.4h-.7v-.6h.6v-.5h.7v.5h.6v.6h-.6v1.4h1"
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M179.3 231.6v-1.3m-.3 1.3v-1.3m-.3 1.3v-1.3m-.4 1.3v-1.3"
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M178 231.6v-1.3m-.5 1.2v-1.2m.2 1.2v-1.2m-.7 1.2v-1.1m.2 1v-1m-.9 1v-1m.2 1v-1m.2 1v-1m-.7 1v-1m-.2.9v-.8m-.2.8v-.8m-.6.8v-.7m.3.7v-.7m-.5.6v-.6m-.2.5v-.4m-.3.3v-.3m-.3.3v-.2"
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.2,
    d: "M173.8 231v-.1"
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M180.8 231.5v-1.2m-.7 1.2v-1.2m-.4 1.3v-1.3m152.6 1.3v-1.3m-.3 1.3v-1.3m-.4 1.3v-1.3m-.4 1.3v-1.3"
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M331 231.6v-1.3m-.6 1.2v-1.1m.3 1.1v-1.2m-.8 1.2v-1.1m.2 1.1v-1.2m-.9 1.1v-1m.2 1v-1m.3 1v-1m-.7 1v-1m-.3 1v-.9m-.2.8v-.8m-.5.8v-.7m.2.7v-.7m-.5.6v-.5m-.2.5v-.5m-.3.4v-.4m-.2.3v-.2"
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.2,
    d: "M326.7 231v-.1"
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M333.7 231.5v-1.2m-.6 1.3v-1.3m-.5 1.3v-1.3"
  })));
};
export default SvgEs;